// src/mimeTypesAndCodecs.ts
var supportMap;
function createMimeCodecSupportList() {
  supportMap = /* @__PURE__ */ new Map();
  supportMap.set(
    "audio/webm;codecs=opus" /* audioWebmOpus */,
    MediaRecorder.isTypeSupported("audio/webm;codecs=opus" /* audioWebmOpus */)
  );
  supportMap.set(
    "audio/mp4;codecs=avc1" /* audioMp4Avc1 */,
    MediaRecorder.isTypeSupported("audio/mp4;codecs=avc1" /* audioMp4Avc1 */)
  );
  supportMap.set(
    "video/webm;codecs=avc1" /* videoWebmAvc1 */,
    MediaRecorder.isTypeSupported("video/webm;codecs=avc1" /* videoWebmAvc1 */)
  );
  supportMap.set(
    "video/webm;codecs=avc1,opus" /* videoWebmAvc1Opus */,
    MediaRecorder.isTypeSupported("video/webm;codecs=avc1,opus" /* videoWebmAvc1Opus */)
  );
  supportMap.set(
    "video/x-matroska;codecs=avc1" /* videoXMatroskaAvc1 */,
    MediaRecorder.isTypeSupported("video/x-matroska;codecs=avc1" /* videoXMatroskaAvc1 */)
  );
  supportMap.set(
    "video/mp4;codecs=avc1" /* videoMp4Avc1 */,
    MediaRecorder.isTypeSupported("video/mp4;codecs=avc1" /* videoMp4Avc1 */)
  );
  supportMap.set(
    "video/webm;codecs=vp8" /* videoWebmVp8 */,
    MediaRecorder.isTypeSupported("video/webm;codecs=vp8" /* videoWebmVp8 */)
  );
  supportMap.set(
    "video/webm;codecs=vp9" /* videoWebmVp9 */,
    MediaRecorder.isTypeSupported("video/webm;codecs=vp9" /* videoWebmVp9 */)
  );
  supportMap.set(
    "video/webm;codecs=av1" /* videoWebmAv1 */,
    MediaRecorder.isTypeSupported("video/webm;codecs=av1" /* videoWebmAv1 */)
  );
}
var MediaFileUtils = class {
  /**Returns the file extension without period for a media file matching a
   * mimetype codec string constant from MimeCodecsString.
   * example: "audio/webm;codecs=opus" */
  static getFileExtension(mimeCodecString) {
    switch (mimeCodecString) {
      case "audio/webm;codecs=opus" /* audioWebmOpus */:
        return "webm";
      case "audio/mp4;codecs=avc1" /* audioMp4Avc1 */:
        return "mp4";
      case "video/webm;codecs=avc1" /* videoWebmAvc1 */:
        return "webm";
      case "video/webm;codecs=avc1,opus" /* videoWebmAvc1Opus */:
        return "webm";
      case "video/x-matroska;codecs=avc1" /* videoXMatroskaAvc1 */:
        return "mkv";
      case "video/mp4;codecs=avc1" /* videoMp4Avc1 */:
        return "mp4";
      case "video/webm;codecs=vp8" /* videoWebmVp8 */:
        return "webm";
      case "video/webm;codecs=vp9" /* videoWebmVp9 */:
        return "webm";
      case "video/webm;codecs=av1" /* videoWebmAv1 */:
        return "webm";
      default:
        throw "Unsupported audioInfo string";
    }
  }
  /**Returns the mimetype for a media file matching a mimetype codec string
   * constant from MimeCodecsString.*/
  static getMimeType(mimeCodecString) {
    switch (mimeCodecString) {
      case "audio/webm;codecs=opus" /* audioWebmOpus */:
        return "audio/webm";
      case "audio/mp4;codecs=avc1" /* audioMp4Avc1 */:
        return "audio/mp4";
      case "video/webm;codecs=avc1" /* videoWebmAvc1 */:
        return "video/webm";
      case "video/webm;codecs=avc1,opus" /* videoWebmAvc1Opus */:
        return "video/webm";
      case "video/x-matroska;codecs=avc1" /* videoXMatroskaAvc1 */:
        return "video/x-matroska";
      case "video/mp4;codecs=avc1" /* videoMp4Avc1 */:
        return "video/mp4";
      case "video/webm;codecs=vp8" /* videoWebmVp8 */:
        return "video/webm";
      case "video/webm;codecs=vp9" /* videoWebmVp9 */:
        return "video/webm";
      case "video/webm;codecs=av1" /* videoWebmAv1 */:
        return "video/webm";
      default:
        throw "Unsupported audioInfo string";
    }
  }
  /**Returns the codecs from a mimeCodecString as an array of strings*/
  static getCodec(mimeCodecsString) {
    let idx = mimeCodecsString.indexOf("=") + 1;
    let subs = mimeCodecsString.substring(idx);
    return subs.split(",");
  }
  /**Returns the container portion from a mimeCodecsString */
  static getContainer(mimeCodecsString) {
    let idx1 = mimeCodecsString.indexOf("/") + 1;
    let idx2 = mimeCodecsString.indexOf(";");
    if (idx1 === -1 || idx2 === -1) {
      throw "unsupported MimeCodecsString format";
    }
    return mimeCodecsString.substring(idx1, idx2);
  }
  /**returns true if the current browser can record the requested type */
  static isMimeCodecSupported(type) {
    if (supportMap == null) {
      createMimeCodecSupportList();
    }
    return supportMap.get(type);
  }
  /**returns true if the current browser can play back (but not necessarily
   * record) content with this MimeCodecString type */
  static canPlayMimeCodec(mimeCodecString) {
    switch (mimeCodecString) {
      case "audio/webm;codecs=opus" /* audioWebmOpus */: {
        return true;
      }
      case "audio/mp4;codecs=avc1" /* audioMp4Avc1 */: {
        return true;
      }
      case "video/webm;codecs=avc1" /* videoWebmAvc1 */: {
        return supportMap.get("video/webm;codecs=avc1" /* videoWebmAvc1 */);
      }
      case "video/webm;codecs=avc1,opus" /* videoWebmAvc1Opus */: {
        return supportMap.get("video/webm;codecs=avc1" /* videoWebmAvc1 */);
      }
      case "video/x-matroska;codecs=avc1" /* videoXMatroskaAvc1 */: {
        return supportMap.get("video/webm;codecs=avc1" /* videoWebmAvc1 */);
      }
      case "video/mp4;codecs=avc1" /* videoMp4Avc1 */: {
        return true;
      }
      case "video/webm;codecs=vp8" /* videoWebmVp8 */: {
        return supportMap.get("video/webm;codecs=vp8" /* videoWebmVp8 */);
      }
      case "video/webm;codecs=vp9" /* videoWebmVp9 */: {
        return supportMap.get("video/webm;codecs=vp9" /* videoWebmVp9 */);
      }
      case "video/webm;codecs=av1" /* videoWebmAv1 */: {
        return supportMap.get("video/webm;codecs=av1" /* videoWebmAv1 */);
      }
      default:
        throw "Unsupported audioInfo string";
    }
  }
};
MediaFileUtils._audioEl = document.createElement("audio");
MediaFileUtils._videoEl = document.createElement("video");
var MimeCodecsString = /* @__PURE__ */ ((MimeCodecsString3) => {
  MimeCodecsString3["audioWebmOpus"] = "audio/webm;codecs=opus";
  MimeCodecsString3["audioMp4Avc1"] = "audio/mp4;codecs=avc1";
  MimeCodecsString3["videoWebmAvc1"] = "video/webm;codecs=avc1";
  MimeCodecsString3["videoWebmAvc1Opus"] = "video/webm;codecs=avc1,opus";
  MimeCodecsString3["videoXMatroskaAvc1"] = "video/x-matroska;codecs=avc1";
  MimeCodecsString3["videoMp4Avc1"] = "video/mp4;codecs=avc1";
  MimeCodecsString3["videoWebmVp8"] = "video/webm;codecs=vp8";
  MimeCodecsString3["videoWebmVp9"] = "video/webm;codecs=vp9";
  MimeCodecsString3["videoWebmAv1"] = "video/webm;codecs=av1";
  return MimeCodecsString3;
})(MimeCodecsString || {});

// src/analysis/AssessmentInstrumentDO.ts
var AssessmentInstrumentDO = class {
  get label() {
    return this.name;
  }
  constructor(id, name, {
    assessmentType,
    transposition,
    minFreq,
    maxFreq,
    yinQuality,
    windowWidth,
    sampleRate,
    pRecMethod,
    pRecQuality,
    overSampTimes,
    requiredPitchesPerSecond,
    tuningWindow,
    ignoreOctave,
    checkNoteStartTimes,
    timeBucketLeft,
    timeBucketRight,
    minAmplPerc,
    psMinPitchStabilityThresh,
    psPitchesToConsider,
    psMinStablePitches,
    psMinTotalPitchJump,
    asMinAmplPercRise,
    asMaxAmplRiseTime,
    spMinTimeBetweenSplits,
    minTimeBetweenClaps,
    minAmplRatioToFloor,
    minConsecutiveQuietPeaks,
    minAmplSlopeScore,
    qNoteNudge,
    qNoteBucket
  }) {
    this.id = id;
    this.name = name;
    this.assessmentType = assessmentType;
    this.transposition = transposition;
    this.minFreq = minFreq;
    this.maxFreq = maxFreq;
    this.yinQuality = yinQuality;
    this.windowWidth = windowWidth;
    this.sampleRate = sampleRate;
    this.pRecMethod = pRecMethod;
    this.pRecQuality = pRecQuality;
    this.overSampTimes = overSampTimes;
    this.requiredPitchesPerSecond = requiredPitchesPerSecond;
    this.tuningWindow = tuningWindow;
    this.ignoreOctave = ignoreOctave;
    this.checkNoteStartTimes = checkNoteStartTimes;
    this.timeBucketLeft = timeBucketLeft;
    this.timeBucketRight = timeBucketRight;
    this.minAmplPerc = minAmplPerc;
    this.psMinStablePitches = psMinStablePitches;
    this.psPitchesToConsider = psPitchesToConsider;
    this.psMinTotalPitchJump = psMinTotalPitchJump;
    this.psMinPitchStabilityThresh = psMinPitchStabilityThresh;
    this.asMinAmplPercRise = asMinAmplPercRise;
    this.asMaxAmplRiseTime = asMaxAmplRiseTime;
    this.spMinTimeBetweenSplits = spMinTimeBetweenSplits;
    this.minTimeBetweenClaps = minTimeBetweenClaps;
    this.minAmplRatioToFloor = minAmplRatioToFloor;
    this.minConsecutiveQuietPeaks = minConsecutiveQuietPeaks;
    this.minAmplSlopeScore = minAmplSlopeScore;
    this.qNoteNudge = qNoteNudge;
    this.qNoteBucket = qNoteBucket;
  }
};

// src/analysis/AssessmentInstrumentUtils.ts
var _AssessmentInstrumentUtils = class _AssessmentInstrumentUtils {
  static getInstrumentByID(id) {
    for (let inst of _AssessmentInstrumentUtils.instruments) {
      if (inst.id === id) {
        return inst;
      }
    }
    return null;
  }
};
_AssessmentInstrumentUtils.instruments = [
  new AssessmentInstrumentDO(3, "Soprano Recorder", {
    assessmentType: 1,
    transposition: -12,
    minFreq: 400,
    maxFreq: 2500,
    yinQuality: 1,
    windowWidth: 256,
    pRecMethod: 1,
    pRecQuality: 10,
    overSampTimes: 2,
    requiredPitchesPerSecond: 30,
    tuningWindow: 50,
    ignoreOctave: false,
    checkNoteStartTimes: true,
    timeBucketLeft: 0.3,
    timeBucketRight: 0.45,
    psMinStablePitches: 6,
    psPitchesToConsider: 9,
    psMinTotalPitchJump: 60,
    psMinPitchStabilityThresh: 50,
    asMinAmplPercRise: 1,
    asMaxAmplRiseTime: 0.05,
    spMinTimeBetweenSplits: 0.1,
    minAmplPerc: 0.05
  }),
  new AssessmentInstrumentDO(4, "Alto Recorder Transposed", {
    assessmentType: 1,
    transposition: -5,
    minFreq: 300,
    maxFreq: 2e3,
    yinQuality: 1
  }),
  new AssessmentInstrumentDO(300, "Alto Recorder", {
    assessmentType: 1,
    transposition: 0,
    minFreq: 300,
    maxFreq: 2e3,
    yinQuality: 1
  }),
  new AssessmentInstrumentDO(301, "Tenor Recorder", {
    assessmentType: 1,
    transposition: 0,
    minFreq: 200,
    maxFreq: 1250,
    yinQuality: 2
  }),
  new AssessmentInstrumentDO(302, "Bass Recorder Transposed", {
    assessmentType: 1,
    transposition: 7,
    minFreq: 150,
    maxFreq: 1e3,
    yinQuality: 2
  }),
  new AssessmentInstrumentDO(303, "Bass Recorder", {
    assessmentType: 1,
    transposition: -12,
    minFreq: 150,
    maxFreq: 1e3,
    yinQuality: 2
  }),
  new AssessmentInstrumentDO(400, "Tin Whistle in D", {
    assessmentType: 1,
    transposition: -12,
    minFreq: 400,
    maxFreq: 2500,
    yinQuality: 1
  }),
  new AssessmentInstrumentDO(5, "Piccolo", {
    assessmentType: 1,
    transposition: -12,
    minFreq: 500,
    maxFreq: 4500,
    yinQuality: 1
  }),
  new AssessmentInstrumentDO(6, "Flute", {
    assessmentType: 1,
    transposition: 0,
    minFreq: 200,
    maxFreq: 2500,
    yinQuality: 1
  }),
  new AssessmentInstrumentDO(200, "Alto Flute", {
    assessmentType: 1,
    transposition: 5,
    minFreq: 150,
    maxFreq: 2200,
    yinQuality: 1
  }),
  new AssessmentInstrumentDO(7, "Oboe", {
    assessmentType: 1,
    transposition: 0,
    minFreq: 200,
    maxFreq: 2200,
    yinQuality: 2
  }),
  new AssessmentInstrumentDO(210, "English Horn", {
    assessmentType: 1,
    transposition: 7,
    minFreq: 130,
    maxFreq: 1700,
    yinQuality: 2
  }),
  new AssessmentInstrumentDO(8, "Bassoon", {
    assessmentType: 1,
    transposition: 0,
    minFreq: 50,
    maxFreq: 1200,
    yinQuality: 4
  }),
  new AssessmentInstrumentDO(9, "Clarinet", {
    assessmentType: 1,
    transposition: 2,
    minFreq: 120,
    maxFreq: 2e3,
    yinQuality: 2
  }),
  new AssessmentInstrumentDO(10, "Bass Clarinet", {
    assessmentType: 1,
    transposition: 14,
    minFreq: 60,
    maxFreq: 1e3,
    yinQuality: 4
  }),
  new AssessmentInstrumentDO(11, "Soprano Sax", {
    assessmentType: 1,
    transposition: 2,
    minFreq: 140,
    maxFreq: 1800,
    yinQuality: 2
  }),
  new AssessmentInstrumentDO(12, "Alto Sax", {
    assessmentType: 1,
    transposition: 9,
    minFreq: 100,
    maxFreq: 1200,
    yinQuality: 3
  }),
  new AssessmentInstrumentDO(13, "Tenor Sax", {
    assessmentType: 1,
    transposition: 14,
    minFreq: 70,
    maxFreq: 1e3,
    yinQuality: 3
  }),
  new AssessmentInstrumentDO(14, "Bari Sax", {
    assessmentType: 1,
    transposition: 21,
    minFreq: 50,
    maxFreq: 600,
    yinQuality: 4
  }),
  new AssessmentInstrumentDO(15, "Trumpet", {
    assessmentType: 1,
    transposition: 2,
    minFreq: 140,
    maxFreq: 2e3,
    yinQuality: 2
  }),
  new AssessmentInstrumentDO(16, "Horn in F", {
    assessmentType: 1,
    transposition: 7,
    minFreq: 90,
    maxFreq: 1400,
    yinQuality: 3
  }),
  new AssessmentInstrumentDO(17, "Trombone", {
    assessmentType: 1,
    transposition: 0,
    minFreq: 60,
    maxFreq: 1e3,
    yinQuality: 4
  }),
  new AssessmentInstrumentDO(18, "Euphonium TC", {
    assessmentType: 1,
    transposition: 14,
    minFreq: 60,
    maxFreq: 1e3,
    yinQuality: 4
  }),
  new AssessmentInstrumentDO(19, "Euphonium BC", {
    assessmentType: 1,
    transposition: 0,
    minFreq: 60,
    maxFreq: 1e3,
    yinQuality: 4
  }),
  new AssessmentInstrumentDO(20, "Tuba", {
    assessmentType: 1,
    transposition: 0,
    minFreq: 30,
    maxFreq: 500,
    yinQuality: 6
  }),
  new AssessmentInstrumentDO(21, "Violin", {
    assessmentType: 1,
    transposition: 0,
    minFreq: 150,
    maxFreq: 2500,
    yinQuality: 2
  }),
  new AssessmentInstrumentDO(22, "Viola", {
    assessmentType: 1,
    transposition: 0,
    minFreq: 110,
    maxFreq: 1800,
    yinQuality: 2
  }),
  new AssessmentInstrumentDO(23, "Cello", {
    assessmentType: 1,
    transposition: 0,
    minFreq: 55,
    maxFreq: 1e3,
    yinQuality: 4
  }),
  new AssessmentInstrumentDO(24, "Bass", {
    assessmentType: 1,
    transposition: 12,
    minFreq: 30,
    maxFreq: 600,
    yinQuality: 6
  }),
  new AssessmentInstrumentDO(25, "Piano", {
    assessmentType: 0,
    transposition: 0,
    minFreq: 20,
    maxFreq: 4400,
    yinQuality: 1
  }),
  new AssessmentInstrumentDO(26, "Guitar", {
    assessmentType: 0,
    transposition: 12,
    minFreq: 70,
    maxFreq: 1300,
    yinQuality: 1
  }),
  new AssessmentInstrumentDO(30, "Bells", {
    assessmentType: 1,
    transposition: -24,
    minFreq: 520,
    maxFreq: 4200,
    yinQuality: 1
  }),
  new AssessmentInstrumentDO(101, "Clap", {
    assessmentType: 2,
    minTimeBetweenClaps: 80,
    minAmplRatioToFloor: 5,
    minConsecutiveQuietPeaks: 0,
    minAmplSlopeScore: 1.5,
    qNoteNudge: -0.15,
    qNoteBucket: 0.25
  }),
  new AssessmentInstrumentDO(102, "Rhythm Voice", {
    assessmentType: 2,
    minTimeBetweenClaps: 120,
    minAmplRatioToFloor: 4,
    minConsecutiveQuietPeaks: 0,
    minAmplSlopeScore: 1.5,
    qNoteNudge: -0.2,
    qNoteBucket: 0.25
  })
];
var AssessmentInstrumentUtils = _AssessmentInstrumentUtils;

// src/analysis/DelayInfo.ts
var DelayInfo = class {
};

// src/analysis/DelayTester.ts
import { SoundLoader } from "audio_utils";

// src/mic/MicManager.ts
import { createEmitter as createEmitter3 } from "ts_utils";

// src/audio_worklets/MicDataNode.ts
import { createEmitter } from "ts_utils";
var _MicDataNode = class _MicDataNode extends AudioWorkletNode {
  constructor(context) {
    super(context, "micData-worklet");
    this._micDataEmitter = createEmitter();
    this._onProcessorMessage = (ev) => {
      this._micDataEmitter.emit(ev.data);
    };
    if (!_MicDataNode.workletRegistered) {
      throw "call registerWorklet() before instantiating";
    }
    this._context = context;
    this._init();
  }
  get micData() {
    return this._micDataEmitter.event;
  }
  static async registerWorklet(context) {
    if (_MicDataNode.workletRegistered) {
      return true;
    }
    try {
      let blob = new Blob([micDataWorklet], { type: "text/javascript" });
      let url = window.URL.createObjectURL(blob);
      await context.audioWorklet.addModule(url);
      _MicDataNode.workletRegistered = true;
      return true;
    } catch (err) {
      console.log(err);
      return false;
    }
  }
  setWindowSize(windowSize) {
    this.port.postMessage({
      type: "setWindowSize",
      windowSize
    });
  }
  _init() {
    this.port.onmessage = this._onProcessorMessage;
  }
};
_MicDataNode.workletRegistered = false;
var MicDataNode = _MicDataNode;
var micDataWorklet = `
class MicDataProcessor extends AudioWorkletProcessor {
	windowSize = 128;
	windowPosition = 0;
	windowData;
	
	constructor(){
		super();
		this.port.onmessage = this._handleMessage;
		this.windowData = new Float32Array(this.windowSize);
		this.windowPosition = 0;
	}
	
	process(inputs, outputs) {
		// By default, the node has single input and output.
		//input[0][0] is the Float32Array of left channel data
		
		const newData = inputs[0][0];
		if (newData == null){
			return true;
		}
		
		let newDataPos = 0;
		while(true){
			let windowSpotsRemaining = this.windowSize - this.windowPosition;
			let newSamplesRemaining = newData.length - newDataPos;
			
			if (newSamplesRemaining >= windowSpotsRemaining){
				let numSamplesToCopy = windowSpotsRemaining;
				this.windowData.set(newData.subarray(newDataPos, newDataPos +
					numSamplesToCopy), this.windowPosition);
				newDataPos += numSamplesToCopy;
				
				this.port.postMessage(this.windowData);
				this.windowData = new Float32Array(this.windowSize);
				this.windowPosition = 0;
			}
			else {
				let numSamplesToCopy = newSamplesRemaining;
				this.windowData.set(newData.subarray(newDataPos, newDataPos +
					numSamplesToCopy), this.windowPosition);
				this.windowPosition += numSamplesToCopy
				break;
			}
		}
		
		return true;
	}
	
	_handleMessage = (ev) => {
		if (ev.data.type === "setWindowSize"){
			this.windowSize = ev.data.windowSize;
			this.windowData = new Float32Array(this.windowSize);
			this.windowPosition = 0;
		}
	}
}

registerProcessor('micData-worklet', MicDataProcessor);
`;

// src/devices/devices.ts
import { createEmitter as createEmitter2 } from "ts_utils";

// src/mic/MicOptions.ts
var MicOptions = class {
  constructor() {
    this.channelCount = 1;
    this.autoGainControl = false;
    this.echoCancellation = false;
    this.latency = 0;
    this.noiseSuppression = false;
  }
  toMap(deviceId) {
    let settings = {
      "channelCount": this.channelCount,
      "autoGainControl": this.autoGainControl,
      "echoCancellation": this.echoCancellation,
      "latency": this.latency,
      "noiseSuppression": this.noiseSuppression
    };
    if (deviceId != null) {
      settings["deviceId"] = deviceId;
    }
    return settings;
  }
};

// src/video/VideoOptions.ts
var VideoOptions = class {
  constructor(width = 320, height = 240, idealFrameRate = 12, maxFrameRate = 15, bitRate = 1e6, recordingBlobSize = 100) {
    this.mimeCodecsString = "video/webm;codecs=avc1,opus" /* videoWebmAvc1Opus */;
    this.width = width;
    this.height = height;
    this.idealFrameRate = idealFrameRate;
    this.maxFrameRate = maxFrameRate;
    this.bitRate = bitRate;
    this.recordingBlobSize = recordingBlobSize;
  }
  toMap(deviceId) {
    let settings = {
      "width": { "ideal": this.width },
      "height": { "ideal": this.height },
      "frameRate": {
        "ideal": this.idealFrameRate
      }
    };
    if (deviceId != null) {
      settings["deviceId"] = deviceId;
    }
    return settings;
  }
};

// src/devices/devices.ts
var Device = class {
};
var DeviceType = /* @__PURE__ */ ((DeviceType2) => {
  DeviceType2[DeviceType2["audioInput"] = 0] = "audioInput";
  DeviceType2[DeviceType2["videoInput"] = 1] = "videoInput";
  DeviceType2[DeviceType2["audioOutput"] = 2] = "audioOutput";
  return DeviceType2;
})(DeviceType || {});
var MediaDeviceManagerEvent = class {
};
var MediaDeviceManagerEventType = /* @__PURE__ */ ((MediaDeviceManagerEventType2) => {
  MediaDeviceManagerEventType2[MediaDeviceManagerEventType2["deviceChange"] = 0] = "deviceChange";
  return MediaDeviceManagerEventType2;
})(MediaDeviceManagerEventType || {});
var MediaDeviceManager = class _MediaDeviceManager {
  constructor() {
    this._micPermissionGranted = false;
    this._cameraPermissionGranted = false;
    this._isInitialized = false;
    this._eventEmitter = createEmitter2();
    this._onDeviceChange = async (e) => {
      await this.getDevices();
      let micChanged = this._currentMic != null && !this.deviceAvailable(this._currentMic.id);
      let cameraChanged = this._currentCamera != null && !this.deviceAvailable(this._currentCamera.id);
      if (micChanged || cameraChanged) {
        this._dispatchDeviceChangeEvent(micChanged, cameraChanged);
      }
    };
  }
  get devices() {
    return this._devices.slice();
  }
  /**returns the currently specified audio input [Device]. Use [isMicReady]
   * to ensure the [currentMic] has been set and permission has been granted
   * to use it.*/
  get currentMic() {
    return this._currentMic;
  }
  /**returns the currently specified video input [Device]. Use [isCameraReady]
   * to ensure the [currentCamera] has been set and permission has been 
   * granted to use it.*/
  get currentCamera() {
    return this._currentCamera;
  }
  /**returns true if the user has granted permission to use the microphone in
   * this session or a previous session. Use [isMicReady] instead to ensure
   * the [currentMic] has also been set in addition to permission being
   * granted.*/
  get micPermissionGranted() {
    return this._micPermissionGranted;
  }
  /**returns true if the user has granted permission to use the camera in
   * this session or a previous session. Use [isCameraReady] instead to ensure
   * the [currentCamera] has also been set in addition to permission being
   * granted.*/
  get cameraPermissionGranted() {
    return this._cameraPermissionGranted;
  }
  /**returns true if the user has granted permission to use the microphone
   * and the [currentMic] has been specified. This must be [true] in order
   * to initiate a mic stream.*/
  get isMicReady() {
    return this._micPermissionGranted && this._currentMic != null;
  }
  /**returns true if the user has granted permission to use the microphone
   * and the [currentCamera] has been specified. This must be [true] in order
   * to initiate a camera stream.*/
  get isCameraReady() {
    return this._cameraPermissionGranted && this._currentCamera != null;
  }
  static get isInitialized() {
    return this._ref != null && this._ref._isInitialized;
  }
  get event() {
    return this._eventEmitter.event;
  }
  static get() {
    if (!_MediaDeviceManager._ref) {
      _MediaDeviceManager._ref = new _MediaDeviceManager();
    }
    return _MediaDeviceManager._ref;
  }
  /**Gets the current state of permissions without prompting the user for 
   * permission or choosing mic/camera devices. You must separately call:
   * [getPermissions] - and request mic and/or camera permissions
   * [getDevices] - to list the available devices
   * [setMic] / [setCamera] - set a current device*/
  async init() {
    if (this._isInitialized) {
      return;
    }
    await this._checkIfPermissionGranted();
    window.navigator.mediaDevices.addEventListener(
      "devicechange",
      this._onDeviceChange
    );
    this._isInitialized = true;
  }
  /**Initializes the list of devices and sets the mic and/or camera to the
   * operating system default devices. The user will be prompted if permission
   * has not already been obtained.*/
  async initWithDefaultDevices(initMic, initCamera) {
    if (!initMic && !initCamera) {
      throw "initWithDefaultDevices should only be used when initiating the mic and/or camera. Alternatively use init()";
    }
    await this.init();
    let success = await this.getPermissions(initMic, initCamera);
    if (!success) {
      return false;
    }
    await this.getDevices();
    let micSuccess = !initMic || this.setMic();
    let cameraSuccess = !initCamera || this.setCamera();
    return micSuccess && cameraSuccess;
  }
  /**Gets permission to use the microphone and/or camera.*/
  async getPermissions(mic, camera) {
    let options = {};
    if (mic && !this._micPermissionGranted) {
      options.audio = new MicOptions().toMap(null);
    }
    if (camera && !this._cameraPermissionGranted) {
      options.video = new VideoOptions().toMap(null);
    }
    if (!options.audio && !options.video) {
      return true;
    }
    let success = await this._createStreams(options);
    if (success) {
      if (!this._micPermissionGranted) {
        this._micPermissionGranted = options.audio != null;
      }
      if (!this._cameraPermissionGranted) {
        this._cameraPermissionGranted = options.video != null;
      }
    }
    success = (!mic || this._micPermissionGranted) && (!camera || this._cameraPermissionGranted);
    return success;
  }
  async getDevices() {
    this._devices = [];
    try {
      let deviceObjects = await navigator.mediaDevices.enumerateDevices();
      for (let dev of deviceObjects) {
        let device = new Device();
        device.id = dev.deviceId;
        device.name = dev.label;
        if (device.id == null) {
          continue;
        }
        switch (dev.kind) {
          case "audioinput":
            device.type = 0 /* audioInput */;
            break;
          case "videoinput":
            device.type = 1 /* videoInput */;
            break;
          case "audiooutput":
            device.type = 2 /* audioOutput */;
            break;
          default:
            continue;
        }
        device.isDefault = !this._devices.some((d) => d.type === device.type);
        this._devices.push(device);
      }
    } catch (err) {
      console.log(err);
    }
    return this._devices;
  }
  /**returns [true] if the requested [deviceId] matches a currently available
   * device*/
  deviceAvailable(deviceId) {
    if (this._devices == null) {
      throw "You must call getDevices() before devices will be available";
    }
    return this._devices.some((d) => d.id == deviceId);
  }
  /**sets the mic device without intializing the mic or asking for permission.
   * If deviceId is left null, the default device will be used.
   * Dispatches an event of type [MediaDeviceManagerEventType.deviceChange] if
   * the device is successfully set.*/
  setMic(deviceId = null) {
    if (!this._micPermissionGranted) {
      throw "You must call getPermissions() and getDevices() before setting a microphone device";
    }
    if (deviceId == null) {
      deviceId = this._devices.find((d) => d.type == 0 /* audioInput */ && d.isDefault)?.id;
    }
    if (deviceId == null || !this.deviceAvailable(deviceId)) {
      return false;
    }
    this._currentMic = this._devices.find((d) => d.id == deviceId);
    this._dispatchDeviceChangeEvent(true, false);
    return true;
  }
  /**sets the mic device to null and dispatches an event of type
   * [MediaDeviceManagerEventType.deviceChange]*/
  clearMic() {
    this._currentMic = null;
    this._dispatchDeviceChangeEvent(true, false);
  }
  /**sets the camera device without intializing the camera or asking for 
   * permission. If deviceId is left null, the default device will be used.
   * Dispatches an event of type [MediaDeviceManagerEventType.deviceChange] if
   * the device is successfully set.*/
  setCamera(deviceId = null) {
    if (!this._cameraPermissionGranted) {
      throw "You must call getPermissions() and getDevices() before setting a camera device";
    }
    if (deviceId == null) {
      deviceId = this._devices.find((d) => d.type == 1 /* videoInput */ && d.isDefault)?.id;
    }
    if (deviceId == null || !this.deviceAvailable(deviceId)) {
      return false;
    }
    this._currentCamera = this._devices.find((d) => d.id == deviceId);
    this._dispatchDeviceChangeEvent(false, true);
    return true;
  }
  /**sets the camera device to null and dispatches an event of type
   * [MediaDeviceManagerEventType.deviceChange]*/
  clearCamera() {
    this._currentCamera = null;
    this._dispatchDeviceChangeEvent(false, true);
  }
  async _createStreams(options) {
    try {
      let stream = await navigator.mediaDevices.getUserMedia(options);
      let tracks = stream.getTracks();
      for (let track of tracks) {
        track.stop();
        track.enabled = false;
        stream.removeTrack(track);
      }
      stream = null;
      return true;
    } catch (err) {
      console.log(err.toString() + "could not enable mic and/or camera");
      return false;
    }
  }
  async _checkIfPermissionGranted() {
    try {
      let status = await navigator.permissions.query(
        { name: "microphone" }
      );
      if (status.state === "granted") {
        this._micPermissionGranted = true;
      }
      status = await navigator.permissions.query(
        { name: "camera" }
      );
      if (status.state === "granted") {
        this._cameraPermissionGranted = true;
      }
    } catch (err) {
    }
  }
  _dispatchDeviceChangeEvent(micChanged, cameraChanged) {
    let ev = new MediaDeviceManagerEvent();
    ev.type = 0 /* deviceChange */;
    ev.micChanged = micChanged;
    ev.cameraChanged = cameraChanged;
    this._eventEmitter.emit(ev);
  }
};

// src/mic/AudioOptions.ts
var AudioOptions = class {
  constructor() {
    this.bitRate = 128e3;
    this.mimeCodecsString = "audio/webm;codecs=opus" /* audioWebmOpus */;
  }
};

// src/mic/MicManager.ts
var _MicManager = class _MicManager {
  constructor(context, options) {
    this._micDataEmitter = createEmitter3();
    this._eventEmitter = createEmitter3();
    this._recordingBufferSize = 1024;
    this._isCapturing = false;
    this._micOptions = new MicOptions();
    this._onMicData = (data) => {
      if (data.length < 1) {
        return;
      } else {
        this._micDataEmitter.emit(data);
      }
    };
    this._onMediaDeviceManagerEvent = (e) => {
      if (e.micChanged || this.includesVideo && e.cameraChanged) {
        this.killStream();
      }
    };
    this._context = context;
    this._audioOptions = options != null ? options : new AudioOptions();
    this._init();
  }
  get micData() {
    return this._micDataEmitter.event;
  }
  get event() {
    return this._eventEmitter.event;
  }
  /**Creates/gets a [MicManager] singleton. [context] is only necessary the
   * first time the constructor is called and will be ignored on future calls.
   * */
  static get(context, options) {
    if (!_MicManager._ref) {
      _MicManager._ref = new _MicManager(context, options);
    }
    return _MicManager._ref;
  }
  _init() {
    if (this._context == null) {
      throw "AudioContext must be specified the first time you callMicManager.get().";
    }
    if (!MediaDeviceManager.isInitialized) {
      throw "You must instantiate and initialize a MediaDeviceManager before creating the MicManager";
    }
    MediaDeviceManager.get().event.on(this._onMediaDeviceManagerEvent);
  }
  /**kills any existing media stream and initializes a new one. If successful,
   * resolves true, otherwise false. If [VideoOptions] is null, only audio
   * input is initialized. This can also be used to disable video recording.*/
  async initMicMediaStream(micOptions = null, videoOptions = null) {
    let deviceManager = MediaDeviceManager.get();
    if (!deviceManager.isMicReady) {
      throw "You must set a mic device in the MediaDeviceManager and get permission to use it before creating media streams.";
    }
    if (videoOptions != null && !deviceManager.isCameraReady) {
      throw "You must set a camera device in the MediaDeviceManager and get permission to use it before adding a video stream.";
    }
    await this._setupWorklets();
    this.killStream();
    if (micOptions != null) {
      this._micOptions = micOptions;
    }
    this._videoOptions = videoOptions;
    let video;
    if (this._videoOptions != null) {
      video = this._videoOptions.toMap(deviceManager.currentCamera.id);
    }
    try {
      this._stream = await navigator.mediaDevices.getUserMedia({
        audio: this._micOptions.toMap(deviceManager.currentMic.id),
        video: video ?? false
      });
      let ev = new MicManagerEvent(0 /* streamCreated */);
      this._eventEmitter.emit(ev);
      return true;
    } catch (err) {
      console.log(err.toString() + " ...maybe make sure mic is enabled.");
      return false;
    }
  }
  async addFiltering() {
    let wasCapturing = this._isCapturing;
    this._micOptions.echoCancellation = true;
    this._micOptions.noiseSuppression = true;
    await this.initMicMediaStream(null, this._videoOptions);
    if (wasCapturing) {
      this.startCapture();
    }
  }
  async removeFiltering() {
    let wasCapturing = this._isCapturing;
    this._micOptions.echoCancellation = false;
    this._micOptions.noiseSuppression = false;
    await this.initMicMediaStream(null, this._videoOptions);
    if (wasCapturing) {
      this.startCapture();
    }
  }
  killStream() {
    if (this._stream != null) {
      this.stopCapture();
      let tracks = this._stream.getTracks();
      for (let track of tracks) {
        track.stop();
        track.enabled = false;
        this._stream.removeTrack(track);
      }
      this._stream = null;
      let ev = new MicManagerEvent(1 /* streamClosed */);
      this._eventEmitter.emit(ev);
    }
  }
  startCapture() {
    if (this._isCapturing) {
      return;
    }
    if (this._context == null) {
      throw "AudioContext must be set first!";
    }
    this._inputNode = this._context.createMediaStreamSource(this._stream);
    this._micDataNode = new MicDataNode(this._context);
    this._micDataNode.setWindowSize(this._recordingBufferSize);
    this._micDataNode.micData.on(this._onMicData);
    this._inputNode.connect(this._micDataNode);
    if (this._micMonitorOutput != null) {
      this._inputNode.connect(this._micMonitorOutput);
    }
    this._micDataNode.connect(this._context.destination);
    this._isCapturing = true;
  }
  stopCapture() {
    if (this._isCapturing) {
      this._micDataNode.disconnect();
      this._inputNode.disconnect();
      this._micDataNode.micData.off(this._onMicData);
      this._isCapturing = false;
    }
  }
  /**attempts to check and return the number of mic channels on the current
   * audio MediaStreamTrack. Returns null if the check fails. */
  getNumAudioChannels() {
    if (!this._stream) {
      return null;
    }
    let tracks = this._stream.getAudioTracks();
    if (tracks && tracks.length > 0) {
      let settings = tracks[0].getSettings();
      let count = settings.channelCount;
      if (count !== void 0 && typeof count === "number") {
        return count;
      }
    }
    return null;
  }
  async _setupWorklets() {
    if (!MicDataNode.workletRegistered) {
      await MicDataNode.registerWorklet(this._context);
    }
  }
  get audioContext() {
    return this._context;
  }
  set audioContext(value) {
    this._context = value;
  }
  /**Gets the number of samples in each recording buffer (ex. 1024)*/
  get recordingBufferSize() {
    return this._recordingBufferSize;
  }
  set recordingBufferSize(value) {
    if (value !== 256 && value !== 512 && value !== 1024 && value !== 2048 && value !== 4096 && value !== 8192 && value !== 16384) {
      throw "value must be a power of 2 from 256 - 16384";
    }
    this._recordingBufferSize = value;
  }
  get audioOptions() {
    return this._audioOptions;
  }
  /**Gets the [VideoOptions] that was set via [initMicAndGetPermission] or
   * [initMicMediaStream]. If this is null, [VideoOptions] were not passed
   * in when initializing the microphone. To disable video, pass null for 
   * the video options to either of those methods.*/
  get videoOptions() {
    return this._videoOptions;
  }
  /**true if video streams are created, in addition to the required audio
   * input stream*/
  get includesVideo() {
    return this._videoOptions != null;
  }
  /**[true] if the microphone is currently dispatching mic data through the 
   * [onMicData] stream. The audio is not saved in the [MicManager], so a
   * separate class for recording or analyzing the data should listen to those
   * events.*/
  get isCapturing() {
    return this._isCapturing;
  }
  /**when using capture (via [startCapture]), if the [micMonitorOutput] is
   * not null, the captured mic data will be sent to this node as well. It's
   * intended to be used for mic audio monitoring.*/
  get micMonitorOutput() {
    return this._micMonitorOutput;
  }
  set micMonitorOutput(node) {
    if (this._inputNode != null) {
      if (this._micMonitorOutput != null) {
        try {
          this._inputNode.disconnect(this._micMonitorOutput);
        } catch (err) {
        }
      }
      if (node != null) {
        this._inputNode.connect(node);
      }
    }
    this._micMonitorOutput = node;
  }
  get isStreamActive() {
    return this._stream != null;
  }
  get stream() {
    return this._stream;
  }
  /**returns the [MediaStreamTrack] for the microphone audio*/
  get micAudioTrack() {
    return this._stream?.getAudioTracks()[0];
  }
};
_MicManager.useOldChromeSettings = false;
var MicManager = _MicManager;
var MicManagerEvent = class {
  constructor(type) {
    this.type = type;
  }
};
var MicManagerEventType = /* @__PURE__ */ ((MicManagerEventType2) => {
  MicManagerEventType2[MicManagerEventType2["streamCreated"] = 0] = "streamCreated";
  MicManagerEventType2[MicManagerEventType2["streamClosed"] = 1] = "streamClosed";
  return MicManagerEventType2;
})(MicManagerEventType || {});

// src/mic/AudioRecorder2.ts
import ysFixWebmDuration from "fix-webm-duration";
var AudioRecorder2 = class _AudioRecorder2 {
  constructor(micManager) {
    this._isRecording = false;
    this._fixWebmDuration = false;
    // void _onRecordingStart(html.Event e){
    //This does not seem to be a reliable indicator of exactly when
    //recording begins, possibly because the handler call can be delayed
    //if there is heavy js processing.
    // number cTime = _micManager.audioContext.currentTime;
    // print('rec start time: $_recordStartTime, rec started: $cTime');
    // _recordStartTime = cTime;
    // }
    this._onDataAvailable = (e) => {
      this._recordingBlobs.push(e.data);
      if (!this._isRecording) {
        this._mediaRecorder.removeEventListener(
          "dataavailable",
          this._onDataAvailable
        );
        this._recordingComplete = true;
        this._completeBlobReturn();
      }
    };
    this._onMicManagerEvent = (e) => {
      switch (e.type) {
        case 1 /* streamClosed */:
          if (this._isRecording) {
            this.stop();
            this._recordingBlobs = null;
          }
          this._killMediaRecorder();
          break;
        case 0 /* streamCreated */:
          if (this._isRecording) {
            this.stop();
            this._recordingBlobs = null;
          }
          this._createMediaRecorder();
          break;
      }
    };
    this._micManager = micManager;
    this._init();
  }
  /**
   * start recording.
   * set startMicCapture to true if you aren't initializing it elsewhere
   * (for pitch rec, etc.).
   */
  record() {
    if (!_AudioRecorder2.isSupported) {
      return false;
    }
    if (this._mediaRecorder == null) {
      if (!this._createMediaRecorder()) {
        throw "MediaRecorder could not be created. Make sure to call MicManager.initMicMediaStream before using the AudioRecorder2";
      }
    }
    this._recordingBlobs = [];
    this._mediaRecorder.addEventListener(
      "dataavailable",
      this._onDataAvailable
    );
    this._mediaRecorder.start();
    this._recordStartTime = this._micManager.audioContext.currentTime;
    this._isRecording = true;
    this._recordingComplete = false;
    return true;
  }
  /**stops recording. If stopMicCapture is true, the microphone capture is
   * also stopped in the MicManager.*/
  stop() {
    if (!_AudioRecorder2.isSupported) {
      return;
    }
    if (this._isRecording) {
      this._mediaRecorder.stop();
      this._recordStopTime = this._micManager.audioContext.currentTime;
      this._isRecording = false;
    }
  }
  /**gets recording as an html.Blob object that can be saved to a file*/
  getAudioBlob() {
    return new Promise((resolve, reject) => {
      this._returnBlobCompleter = resolve;
      if (this._recordingComplete) {
        this._completeBlobReturn();
      }
    });
  }
  /**Gets an AudioElement with the recorded audio*/
  async getAudioElement() {
    let blob = await this.getAudioBlob();
    if (blob != null) {
      let audioEl = document.createElement("audio");
      audioEl.src = URL.createObjectURL(blob);
      return audioEl;
    }
    return null;
  }
  _init() {
    this._micManager.event.on(this._onMicManagerEvent);
    this._createMediaRecorder();
  }
  _createMediaRecorder() {
    this._killMediaRecorder();
    if (!this._audioStreamIsReady()) {
      return false;
    }
    try {
      let audioOptions = this._micManager.audioOptions;
      let vidOptions = this._micManager.videoOptions;
      let options = this.recordingVideo ? {
        "mimeType": vidOptions.mimeCodecsString,
        "audioBitsPerSecond": audioOptions.bitRate,
        "videoBitsPerSecond": vidOptions.bitRate
      } : {
        "mimeType": audioOptions.mimeCodecsString,
        "audioBitsPerSecond": audioOptions.bitRate
      };
      this._mediaRecorder = new MediaRecorder(
        this._micManager.stream,
        options
      );
      return true;
    } catch (err) {
      console.log(err.toString());
      return false;
    }
  }
  _audioStreamIsReady() {
    let audioStreams = this._micManager.stream?.getAudioTracks();
    if (audioStreams == null || audioStreams.length < 1 || audioStreams[0].readyState !== "live") {
      return false;
    }
    return true;
  }
  _completeBlobReturn() {
    if (this._returnBlobCompleter == null) {
      return;
    }
    if (this._recordingBlobs == null || this._recordingBlobs.length === 0) {
      this._recordingBlobs = null;
      this._returnBlobCompleter(null);
      this._returnBlobCompleter = null;
    } else {
      let mimeType = this.recordingVideo ? "video/webm" : "audio/webm";
      let blob = new Blob(this._recordingBlobs, { type: mimeType });
      this._recordingBlobs = null;
      if (!this._fixWebmDuration || !mimeType.includes("webm")) {
        this._returnBlobCompleter(blob);
        this._returnBlobCompleter = null;
      } else {
        let duration = Math.ceil((this._recordStopTime - this._recordStartTime) * 1e3);
        ysFixWebmDuration(blob, duration, (fixedBlob) => {
          this._returnBlobCompleter(fixedBlob);
          this._returnBlobCompleter = null;
        }, { logger: false });
      }
    }
  }
  _killMediaRecorder() {
    if (this._mediaRecorder != null) {
      this._mediaRecorder.removeEventListener(
        "dataavailable",
        this._onDataAvailable
      );
      this._mediaRecorder = null;
    }
  }
  get recordingVideo() {
    return this._micManager.includesVideo;
  }
  /**if true, recording is currently in progress.*/
  get isRecording() {
    return this._isRecording;
  }
  /**returns the AudioContext time, in seconds, when recording starts.*/
  get recordStartTime() {
    return this._recordStartTime;
  }
  /**returns the AudioContext time, in seconds, when recording stops.*/
  get recordStopTime() {
    return this._recordStopTime;
  }
  /**returns the duration of recording, in seconds (not rounded) */
  get recordDuration() {
    return this._recordStopTime - this.recordStartTime;
  }
  /**if fixWebmDuration is true, recordings will be processed to add duration
   * metadata */
  get fixWebmDuration() {
    return this._fixWebmDuration;
  }
  set fixWebmDuration(value) {
    this._fixWebmDuration = value;
  }
  /**returns true if the browser supports the MediaRecorder API*/
  static get isSupported() {
    if (_AudioRecorder2._isSupported == null) {
      _AudioRecorder2._isSupported = MediaRecorder != null;
    }
    return _AudioRecorder2._isSupported;
  }
};

// src/analysis/DelayTester.ts
var DelayTester = class _DelayTester {
  constructor(micManager) {
    this._onMicData = (data) => {
      if (this._micSampleData == null) {
        this._micSampleData = data;
      } else {
        let newList = new Float32Array(this._micSampleData.length + data.length);
        newList.set(this._micSampleData, 0);
        newList.set(data, this._micSampleData.length);
        this._micSampleData = newList;
      }
    };
    if (micManager == null) {
      throw "You must include the MicManager in the first call to DelayTester.get()";
    }
    this._micManager = micManager;
  }
  static get(micManager) {
    if (_DelayTester._ref == null) {
      _DelayTester._ref = new _DelayTester(micManager);
    }
    return _DelayTester._ref;
  }
  /**Tests the length of the delay between when a user makes a sound and that
   * sound is picked up. To use this test, the mic must pick up the speaker
   * sound. A single short tone will play.*/
  testDelay() {
    return new Promise((resolve, reject) => {
      this._micManager.initMicMediaStream().then((_) => {
        let context = this._micManager.audioContext;
        let tone = this._getTestTone(
          512,
          880,
          false
        );
        this._testSampleData = tone.buffer.getChannelData(0);
        this._recorder = new AudioRecorder2(this._micManager);
        this._recorder.record();
        let playDelay = 0;
        tone.start(context.currentTime + playDelay);
        setTimeout(async () => {
          this._recorder.stop();
          let blob = await this._recorder.getAudioBlob();
          let arrayBuffer = await this.convertBlobToArrayBuffer(blob);
          SoundLoader.getDownloadLinkForArrayBuffer(
            [arrayBuffer],
            "audio.webm"
          );
          let buffer = await SoundLoader.getAudioBufferFromBlob(
            blob,
            this._micManager.audioContext
          );
          let result = this._analyzeData(buffer, playDelay);
          resolve(result);
        }, 2e3);
      });
    });
  }
  /**Tests the length of the delay between when a user makes a sound and that
   * sound is picked up. To use this test, the mic must pick up the speaker
   * sound. A single short tone will play.*/
  testDelayViaPeak() {
    let promise = new Promise((resolve, reject) => {
      this._micManager.initMicMediaStream().then((_) => {
        let context = this._micManager.audioContext;
        let tone = this._getTestTone(
          1024,
          880,
          true
        );
        this._recorder = new AudioRecorder2(this._micManager);
        this._recorder.record();
        let playDelay = 0;
        tone.start(context.currentTime + playDelay);
        setTimeout(async () => {
          this._recorder.stop();
          let blob = await this._recorder.getAudioBlob();
          let buffer = await SoundLoader.getAudioBufferFromBlob(
            blob,
            this._micManager.audioContext
          );
          let result = this._analyzeDataPeak(buffer, playDelay);
          resolve(result);
        }, 1e3 + playDelay);
      });
    });
    return promise;
  }
  _getTestTone(numSamples, frequency, fade) {
    let context = this._micManager.audioContext;
    let bs = context.createBuffer(1, numSamples, context.sampleRate);
    let cdata = bs.getChannelData(0);
    let sampleRate = context.sampleRate;
    if (fade) {
      for (let i = 0; i < cdata.length; i++) {
        let fac = 1 * ((cdata.length - i) / cdata.length);
        cdata[i] = fac * Math.sin(i * frequency * 2 * Math.PI / sampleRate);
      }
    } else {
      for (let i = 0; i < cdata.length; i++) {
        cdata[i] = 1 * Math.sin(i * frequency * 2 * Math.PI / sampleRate);
      }
    }
    let bsn = context.createBufferSource();
    bsn.buffer = bs;
    bsn.connect(context.destination);
    return bsn;
  }
  _getSquareTone(numSamples, frequency) {
    let context = this._micManager.audioContext;
    let bs = context.createBuffer(1, numSamples, context.sampleRate);
    let cdata = bs.getChannelData(0);
    let sampleRate = context.sampleRate;
    for (let i = 0; i < cdata.length; i++) {
      let val = Math.sin(i * frequency * 2 * Math.PI / sampleRate);
      if (val > 0) {
        cdata[i] = 0.5;
      } else if (val < 0) {
        cdata[i] = -0.5;
      } else {
        cdata[i] = 0;
      }
    }
    let bsn = context.createBufferSource();
    bsn.buffer = bs;
    bsn.connect(context.destination);
    return bsn;
  }
  _analyzeData(buffer, playDelay) {
    let samples = buffer.getChannelData(0);
    this._normalizeMicSampleData(samples);
    let bestScore = -9999999;
    let bestScoreIndex = -1;
    let i = 0;
    for (i; i < samples.length - this._testSampleData.length; i += 1) {
      let score = 0;
      for (let j = 0; j < this._testSampleData.length; j++) {
        let micSample = samples[i + j];
        let testSample = this._testSampleData[j];
        score += micSample * testSample;
      }
      if (score > bestScore) {
        bestScore = score;
        bestScoreIndex = i;
      }
    }
    let delay = bestScoreIndex / this._micManager.audioContext.sampleRate;
    delay -= playDelay;
    let info = new DelayInfo();
    info.testSuccessful = true;
    info.delay = delay;
    return info;
  }
  _analyzeDataPeak(buffer, playDelay) {
    var samples = buffer.getChannelData(0);
    let max = -1;
    let bestScoreIndex = 0;
    for (let i = 0; i < samples.length; i++) {
      if (samples[i] > max) {
        max = samples[i];
        bestScoreIndex = i;
      }
    }
    let delay = bestScoreIndex / this._micManager.audioContext.sampleRate;
    delay -= playDelay;
    delay *= 1e3;
    delay = Math.round(delay);
    delay /= 1e3;
    let info = new DelayInfo();
    info.testSuccessful = true;
    info.delay = delay;
    return info;
  }
  _normalizeMicSampleData(samples) {
    let max = -1;
    for (let i = 0; i < samples.length; i++) {
      if (samples[i] > max) {
        max = samples[i];
      }
    }
    let fac = 0.5 / max;
    for (let i = 0; i < samples.length; i++) {
      samples[i] *= fac;
    }
  }
  /**Tests the length of the delay between when a user makes a sound and that
   * sound is picked up. To use this test, the mic must pick up the speaker
   * sound. Three short tones will play.*/
  async testDelay2() {
    await this._micManager.initMicMediaStream();
    const frequency = 880;
    const playDelay = 0;
    const recordingGap = 1;
    let testTone = this._getSquareTone(
      512,
      frequency
    );
    let recording1 = await this._test2MakeFirstRecording(
      playDelay,
      testTone
    );
    testTone = this._getSquareTone(512, frequency);
    let recording2 = await this._test2MakeSecondRecording(
      playDelay,
      testTone,
      recording1,
      recordingGap
    );
    let gapTime = this._measureGapBetweenRecordings(
      recording2,
      frequency,
      recordingGap
    );
    let info = new DelayInfo();
    info.testSuccessful = true;
    info.delay = gapTime - recordingGap;
    return info;
  }
  _test2MakeFirstRecording(playDelay, testTone) {
    return new Promise((resolve, reject) => {
      this._micSampleData = null;
      this._micManager.micData.on(this._onMicData);
      this._micManager.startCapture();
      let context = this._micManager.audioContext;
      testTone.start(context.currentTime + playDelay);
      setTimeout(() => {
        this._micManager.micData.off(this._onMicData);
        this._micManager.stopCapture();
        this._normalizeMicSampleData(this._micSampleData);
        let bsn = this._getBufferSourceNodeFromAudio(
          this._micSampleData
        );
        resolve(bsn);
      }, 1e3);
    });
  }
  _test2MakeSecondRecording(playDelay, testTone, recording1, gapBetweenTones) {
    return new Promise((resolve, reject) => {
      this._micSampleData = null;
      this._micManager.micData.on(this._onMicData);
      this._micManager.startCapture();
      let context = this._micManager.audioContext;
      let playDelay2 = 0;
      testTone.start(context.currentTime + playDelay2);
      recording1.start(context.currentTime + playDelay2 + gapBetweenTones);
      setTimeout(() => {
        this._micManager.micData.off(this._onMicData);
        this._micManager.stopCapture();
        this._normalizeMicSampleData(this._micSampleData);
        resolve(this._micSampleData);
      }, 3e3);
    });
  }
  _measureGapBetweenRecordings(sampleData, frequency, gapBetweenTones) {
    let context = this._micManager.audioContext;
    let minSamplesBetweenTones = Math.floor(context.sampleRate * gapBetweenTones);
    let crossings = this._getZeroCrossingIndexes(sampleData);
    let idealGap = context.sampleRate / frequency / 2;
    let lastCrossingIdx = crossings[0];
    let consecutiveMatches = 0;
    let proposedStartIndex = 0;
    let confirmedTestToneIndex = -1;
    let confirmedRecordingIndex = -1;
    for (let i = 1; i < crossings.length; i++) {
      let crossingIdx = crossings[i];
      if (Math.abs(crossingIdx - lastCrossingIdx - idealGap) < 5) {
        consecutiveMatches++;
        if (consecutiveMatches == 1) {
          proposedStartIndex = lastCrossingIdx;
        }
      } else {
        if (consecutiveMatches > 5) {
          if (confirmedTestToneIndex == -1) {
            confirmedTestToneIndex = proposedStartIndex;
          } else if (proposedStartIndex - confirmedTestToneIndex > minSamplesBetweenTones) {
            confirmedRecordingIndex = proposedStartIndex;
            break;
          }
        }
        consecutiveMatches = 0;
      }
      lastCrossingIdx = crossingIdx;
    }
    return (confirmedRecordingIndex - confirmedTestToneIndex) / context.sampleRate;
  }
  _getZeroCrossingIndexes(sampleData) {
    let crossings = [];
    let lastVal = sampleData[0];
    for (let i = 1; i < sampleData.length; i++) {
      let val = sampleData[i];
      if (lastVal >= 0 && val < 0 || lastVal < 0 && val >= 0) {
        crossings.push(i);
      }
      lastVal = val;
    }
    return crossings;
  }
  _getBufferSourceNodeFromAudio(samples) {
    let context = this._micManager.audioContext;
    let buffer = context.createBuffer(
      1,
      samples.length,
      context.sampleRate
    );
    let channel = buffer.getChannelData(0);
    channel.set(samples, 0);
    let bsn = context.createBufferSource();
    bsn.buffer = buffer;
    bsn.connect(context.destination);
    return bsn;
  }
  convertBlobToArrayBuffer(blob) {
    return new Promise((resolve, reject) => {
      let reader = new FileReader();
      reader.onloadend = (e) => {
        reader.onloadend = null;
        reader.onerror = null;
        resolve(reader.result);
      };
      reader.onerror = (err) => {
        reader.onloadend = null;
        reader.onerror = null;
        reject(err);
      };
      reader.readAsArrayBuffer(blob);
    });
  }
};

// src/analysis/DelayTester2.ts
import { SoundLoader as SoundLoader2 } from "audio_utils";
var DelayTester2 = class _DelayTester2 {
  constructor(micManager) {
    if (micManager == null) {
      throw "You must include the MicManager in the first call to DelayTester.get()";
    }
    this._micManager = micManager;
  }
  static get(micManager) {
    if (_DelayTester2._ref == null) {
      _DelayTester2._ref = new _DelayTester2(micManager);
    }
    return _DelayTester2._ref;
  }
  /**Tests the length of the delay between when a user makes a sound and that
   * sound is picked up. To use this test, the mic must pick up the speaker
   * sound. A single short tone will play.*/
  testDelay() {
    const frequency = 880;
    let promise = new Promise((resolve, reject) => {
      this._micManager.initMicMediaStream().then((_) => {
        let context = this._micManager.audioContext;
        let tone = this._getTestTone(
          ~~(context.sampleRate / 2),
          frequency
        );
        this._recorder = new AudioRecorder2(this._micManager);
        this._recorder.record();
        let playDelay = 0;
        tone.start(context.currentTime + playDelay);
        setTimeout(async () => {
          this._recorder.stop();
          let blob = await this._recorder.getAudioBlob();
          let buffer = await SoundLoader2.getAudioBufferFromBlob(
            blob,
            this._micManager.audioContext
          );
          let result = this._analyzeData(
            buffer,
            tone,
            playDelay,
            frequency
          );
          resolve(result);
        }, 1e3 + playDelay);
      });
    });
    return promise;
  }
  _getTestTone(numSamples, frequency) {
    let context = this._micManager.audioContext;
    let bs = context.createBuffer(1, numSamples, context.sampleRate);
    let cdata = bs.getChannelData(0);
    let sampleRate = context.sampleRate;
    for (let i = 0; i < cdata.length; i++) {
      cdata[i] = 0.8 * Math.sin(i * frequency * 2 * Math.PI / sampleRate);
    }
    let bsn = context.createBufferSource();
    bsn.buffer = bs;
    bsn.connect(context.destination);
    return bsn;
  }
  _analyzeData(recording, testTone, playDelay, frequency) {
    let info = new DelayInfo();
    var samples = recording.getChannelData(0);
    let matchingStartIdx = this._getMatchingStartIndex(samples, frequency);
    if (matchingStartIdx == null) {
      info.testSuccessful = false;
      return info;
    }
    let delay = matchingStartIdx / this._micManager.audioContext.sampleRate;
    delay -= playDelay;
    delay *= 1e3;
    delay = Math.round(delay);
    delay /= 1e3;
    info.testSuccessful = true;
    info.delay = delay;
    return info;
  }
  /**using the frequency to determine expected gaps between zero crossings,
   * verify that we have the expected number of segments and return the time
   * of the first. */
  _getMatchingStartIndex(sampleData, frequency) {
    let context = this._micManager._context;
    let targetPeriod = context.sampleRate / frequency;
    let targetInterval = targetPeriod / 2;
    console.log(targetInterval);
    let positiveStartIndexes = [];
    let posStartIdx = -1;
    for (let i = 0; i < sampleData.length; i++) {
      let val = sampleData[i];
      if (val > 0 && posStartIdx === -1) {
        posStartIdx = i;
      } else if (val < 0 && posStartIdx > -1) {
        let interval = i - 1 - posStartIdx;
        if (targetInterval - interval < 2 && interval - targetInterval < 2) {
          positiveStartIndexes.push(posStartIdx);
        }
        posStartIdx = -1;
      }
    }
    return positiveStartIndexes.length > 0 ? positiveStartIndexes[0] : null;
  }
};

// src/analysis/HitRecognizer.ts
import { createEmitter as createEmitter4 } from "ts_utils";
var HitRecognizer = class {
  constructor() {
    this._eventEmitter = createEmitter4();
  }
  get event() {
    return this._eventEmitter.event;
  }
};
var HitType = /* @__PURE__ */ ((HitType2) => {
  HitType2[HitType2["rhythm_hit"] = 0] = "rhythm_hit";
  HitType2[HitType2["rhythm_hit_start"] = 1] = "rhythm_hit_start";
  HitType2[HitType2["rhythm_hit_end"] = 2] = "rhythm_hit_end";
  HitType2[HitType2["beat_hit"] = 3] = "beat_hit";
  return HitType2;
})(HitType || {});
var HitEvent = class {
};

// src/analysis/KeyHitRecognizer.ts
var KeyHitRecognizer = class _KeyHitRecognizer extends HitRecognizer {
  constructor(context) {
    super();
    this._sendStartEndEvents = true;
    this._sendBeatEvents = false;
    this._beatKey = 32;
    //32 = Spacebar
    this._keyStates = /* @__PURE__ */ new Map();
    this._onKeyDown = (e) => {
      if (this._keyStates.get(e.keyCode) === true) {
        return;
      }
      this._keyStates.set(e.keyCode, true);
      let hEvent = new HitEvent();
      if (e.keyCode === this._beatKey && this._sendBeatEvents) {
        hEvent.hitType = 3 /* beat_hit */;
      } else if (this._sendStartEndEvents) {
        hEvent.hitType = 1 /* rhythm_hit_start */;
      } else {
        return;
      }
      hEvent.keycode = e.keyCode;
      hEvent.time = this._context.currentTime;
      this._eventEmitter.emit(hEvent);
    };
    this._onKeyUp = (e) => {
      this._keyStates.set(e.keyCode, false);
      if (!this._sendStartEndEvents) {
        return;
      }
      if (!this._sendBeatEvents || e.keyCode !== this._beatKey) {
        let hEvent = new HitEvent();
        hEvent.hitType = 2 /* rhythm_hit_end */;
        hEvent.keycode = e.keyCode;
        hEvent.time = this._context.currentTime;
        this._eventEmitter.emit(hEvent);
      }
    };
    if (context == null) {
      throw "You must pass an AudioContext to KeyHitRecognizer.get() the first time you call it.";
    }
    this._context = context;
  }
  static get(context) {
    if (_KeyHitRecognizer._ref == null) {
      _KeyHitRecognizer._ref = new _KeyHitRecognizer(context);
    }
    return _KeyHitRecognizer._ref;
  }
  startHitRec() {
    this._removeListeners();
    document.addEventListener("keydown", this._onKeyDown);
    document.addEventListener("keyup", this._onKeyUp);
  }
  stopHitRec() {
    this._removeListeners();
    this._keyStates = /* @__PURE__ */ new Map();
  }
  /**can be used to send a hit without a keypress, such as for a screen
   * tap.*/
  generateHit(type) {
    let hEvent = new HitEvent();
    hEvent.hitType = type;
    hEvent.time = this._context.currentTime;
    this._eventEmitter.emit(hEvent);
  }
  _removeListeners() {
    document.removeEventListener("keydown", this._onKeyDown);
    document.removeEventListener("keyup", this._onKeyUp);
  }
  get sendBeatEvents() {
    return this._sendBeatEvents;
  }
  set sendBeatEvents(value) {
    this._sendBeatEvents = value;
  }
  get sendStartEndEvents() {
    return this._sendStartEndEvents;
  }
  set sendStartEndEvents(value) {
    this._sendStartEndEvents = value;
  }
  get beatKey() {
    return this._beatKey;
  }
  set beatKey(value) {
    this._beatKey = value;
  }
};

// src/analysis/MicHitRecognizer.ts
var MicHitRecognizer = class _MicHitRecognizer extends HitRecognizer {
  constructor(micManager) {
    super();
    this._windowSize = 4096;
    this._onMicData = (data) => {
      let msTime = ~~(this._micManager.audioContext.currentTime * 1e3);
      let msLengthOfData = -~~(1e3 * (data.length / this._micSampleRate));
      if (this._recordDelay === -1) {
        this._recordDelay = msTime - this._recordTimeStamp - msLengthOfData;
      }
      let dataStartTime = msTime - this._recordTimeStamp - msLengthOfData;
      this._processAudioData(data, dataStartTime);
    };
    if (micManager == null) {
      throw "you must provide a MicManager reference when initializing the MicHitRecognizer. Use the static getInstance() method to do this once per application session.";
    }
    this._micManager = micManager;
    this._instDO = AssessmentInstrumentUtils.getInstrumentByID(101);
    this._micSampleRate = ~~this._micManager.audioContext.sampleRate;
  }
  static get(micManager) {
    if (_MicHitRecognizer._ref == null) {
      _MicHitRecognizer._ref = new _MicHitRecognizer(micManager);
    }
    return _MicHitRecognizer._ref;
  }
  startHitRec() {
    this._recordDelay = -1;
    this._lastHitTime = 0;
    this._currentSampleIndex = 0;
    this._samples = [];
    this._averagePeakAmpl = 0;
    this._recentPeaks = [];
    this._floorPeakAmpl = 0;
    this._numPeakReadings = 0;
    this._consecutiveQuietPeaks = 0;
    this._micManager.micData.on(this._onMicData);
    this._recordTimeStamp = ~~(this._micManager.audioContext.currentTime * 1e3);
  }
  stopHitRec() {
    this._micManager.micData.off(this._onMicData);
  }
  setInstrument(instDO) {
    this._instDO = instDO;
  }
  _processAudioData(samplesBA, timeStamp) {
    let numSamples = samplesBA.length;
    for (let i = 0; i < numSamples; i++) {
      this._samples.push(samplesBA[i]);
    }
    let startSampleIndex = this._currentSampleIndex;
    while (this._currentSampleIndex + this._windowSize <= this._samples.length) {
      let cTime = timeStamp + ~~((this._currentSampleIndex - startSampleIndex) / 44.1);
      let windowSamples = [];
      let highestAmpl = -2;
      let lowestAmpl = 2;
      for (let i = this._currentSampleIndex; i < this._currentSampleIndex + this._windowSize; i++) {
        let value = this._samples[i];
        if (value > highestAmpl) {
          highestAmpl = value;
        }
        if (value < lowestAmpl) {
          lowestAmpl = value;
        }
        windowSamples.push(this._samples[i]);
      }
      let maxPeak = lowestAmpl * -1 > highestAmpl ? lowestAmpl * -1 : highestAmpl;
      if (maxPeak < Number.MIN_VALUE) {
        maxPeak = Number.MIN_VALUE;
      }
      this._averagePeakAmpl = (this._averagePeakAmpl * this._numPeakReadings + maxPeak) / (this._numPeakReadings + 1);
      if (this._recentPeaks.length >= 10) {
        this._recentPeaks.splice(0, 1);
      }
      this._recentPeaks.push(maxPeak);
      let highestRecentPeak = this._recentPeaks[0];
      for (let i = 1; i < this._recentPeaks.length; i++) {
        if (this._recentPeaks[i] > highestRecentPeak) {
          highestRecentPeak = this._recentPeaks[i];
        }
      }
      if (this._numPeakReadings < 20) {
        this._floorPeakAmpl = (this._floorPeakAmpl * this._numPeakReadings + highestRecentPeak) / (this._numPeakReadings + 1);
      } else if (highestRecentPeak < this._floorPeakAmpl) {
        this._floorPeakAmpl = (this._floorPeakAmpl * 19 + highestRecentPeak) / 20;
      }
      this._numPeakReadings++;
      if (
        /*highestAmpl > 0.05 &&*/
        cTime - this._lastHitTime > this._instDO.minTimeBetweenClaps
      ) {
        let amplSlopeScore = this._detectHitByAmplSlope(
          windowSamples,
          highestAmpl,
          lowestAmpl
        );
        let peakFloorScore = this._numPeakReadings > 20 ? maxPeak / this._floorPeakAmpl : 0;
        if (peakFloorScore >= this._instDO.minAmplRatioToFloor && this._consecutiveQuietPeaks >= this._instDO.minConsecutiveQuietPeaks && amplSlopeScore >= this._instDO.minAmplSlopeScore) {
          this._consecutiveQuietPeaks = 0;
          this._lastHitTime = cTime;
          let hEvent = new HitEvent();
          hEvent.hitType = 0 /* rhythm_hit */;
          hEvent.time = timeStamp / 1e3;
          this._eventEmitter.emit(hEvent);
        } else if (peakFloorScore < this._instDO.minAmplRatioToFloor) {
          this._consecutiveQuietPeaks++;
        }
      }
      this._currentSampleIndex += ~~(this._windowSize / 2);
    }
  }
  _detectHitByAmplSlope(samplesList, highestAmpl, lowestAmpl) {
    let bestJumpRatio = this._recentPeaks.length > 1 ? this._recentPeaks[this._recentPeaks.length - 1] / this._recentPeaks[this._recentPeaks.length - 2] : 0;
    let score = bestJumpRatio;
    return score;
  }
  _detectHitByJerkiness(samplesList, highestAmpl, lowestAmpl) {
    let numSamples = samplesList.length;
    let prevAmpl;
    let cAmpl = samplesList[0];
    let nextAmpl = samplesList[1];
    let biggestJerk = 0;
    for (let i = 1; i < numSamples - 1; i++) {
      prevAmpl = cAmpl;
      cAmpl = nextAmpl;
      nextAmpl = samplesList[i + 1];
      let midPointAmpl = (prevAmpl + nextAmpl) / 2;
      if (midPointAmpl - cAmpl > 0.01 || cAmpl - midPointAmpl > 0.01) {
        if (midPointAmpl - cAmpl > biggestJerk) {
          biggestJerk = midPointAmpl - cAmpl;
        } else if (cAmpl - midPointAmpl > biggestJerk) {
          biggestJerk = cAmpl - midPointAmpl;
        }
      }
    }
    let score = ~~(100 * biggestJerk);
    if (score > 10) {
      score = 10;
    }
    return score;
  }
};

// src/analysis/PitchRecognizer.ts
import { createEmitter as createEmitter5 } from "ts_utils";
var PitchRecognizer = class {
  constructor(micManager) {
    this._isRunning = false;
    this._eventEmitter = createEmitter5();
    this._onMicData = (data) => {
      let time = this._micManager.audioContext.currentTime;
      let durOfData = data.length / this._micSampleRate;
      if (this._recordDelay === -1) {
        this._recordDelay = time - this._recordTimeStamp - durOfData;
      }
      this._processData(Array.from(data), time - durOfData);
    };
    this._micManager = micManager;
    this._init();
  }
  //in seconds
  get pitchRecMethod() {
    return this._pitchRecMethod;
  }
  /**[true] when pitch rec is running*/
  get isRunning() {
    return this._isRunning;
  }
  get pitchRecEvent() {
    return this._eventEmitter.event;
  }
  _init() {
    this.setInstrument(AssessmentInstrumentUtils.getInstrumentByID(3));
    this._micSampleRate = ~~this._micManager.audioContext.sampleRate;
  }
  /**
   * start pitch rec. 
   * set startMicCapture to true if you aren't planning to use the mic data 
   * elsewhere (for recording, etc.). If you need to keep the recorded data, 
   * you should call MicManager.startCapture() separately and set 
   * startMicCapture to false here.
   */
  startPRec(startMicCapture) {
    this._prEvents = [];
    this._leftOverMicData = [];
    this._recordDelay = -1;
    this._recordTimeStamp = this._micManager.audioContext.currentTime;
    this._micManager.micData.on(this._onMicData);
    if (startMicCapture) {
      this._micManager.startCapture();
    }
    this._isRunning = true;
  }
  stopPRec(stopMicCapture) {
    this._micManager.micData.off(this._onMicData);
    if (stopMicCapture) {
      this._micManager.stopCapture();
    }
    this._isRunning = false;
  }
  setInstrument(instDO) {
    this._minFreq = instDO.minFreq;
    this._maxFreq = instDO.maxFreq;
    this._windowWidth = instDO.windowWidth;
    this._resampleDivisor = 1;
    if (instDO.sampleRate != null) {
      let sampleRate = instDO.sampleRate;
      while (sampleRate <= this._micSampleRate / 2) {
        this._resampleDivisor *= 2;
        sampleRate *= 2;
      }
    }
    this._quality = instDO.pRecQuality;
    this._pitchRecMethod = instDO.pRecMethod;
    this._overSampTimes = instDO.overSampTimes;
  }
  _processData(data, timeStamp) {
    if (this._leftOverMicData.length > 0) {
      this._leftOverMicData.push(...data);
      data = this._leftOverMicData;
    }
    let pitchesToRead = ~~(data.length / (this._windowWidth * this._resampleDivisor));
    let secondsPerPitch = this._windowWidth / this._micSampleRate;
    let secondsPerOverSampIteration = secondsPerPitch / this._overSampTimes;
    let dataPos = 0;
    for (let i = 0; i < pitchesToRead; i++) {
      let overSampIteration = 0;
      while (overSampIteration < this._overSampTimes && i < pitchesToRead - 1 || i === pitchesToRead - 1 && overSampIteration === 0) {
        let curData = new Array(this._windowWidth);
        let sum = 0;
        let value;
        let peakAmpl = 0;
        for (let j = 0; j < this._windowWidth; j++) {
          value = data[dataPos];
          sum += value * value;
          if (value > peakAmpl) {
            peakAmpl = value;
          }
          curData[j] = value;
          dataPos += this._resampleDivisor;
        }
        let rms = Math.sqrt(sum / this._windowWidth);
        let adjustedStartTime = timeStamp + i * secondsPerPitch + overSampIteration * secondsPerOverSampIteration;
        let frequency;
        switch (this._pitchRecMethod) {
          case 1:
            frequency = this._autoCorrelateProductDifferenceMethod(
              curData,
              peakAmpl
            );
            break;
          default:
            console.log("unsupported method! PitchRecognizer.processData()");
        }
        if (frequency > 0) {
          this._notifyOfPitch(
            frequency,
            adjustedStartTime,
            rms,
            peakAmpl
          );
        }
        overSampIteration++;
        dataPos = overSampIteration * ~~(this._windowWidth / this._overSampTimes);
      }
    }
  }
  /**method 1
   * product peak and subtraction average sum method*/
  _autoCorrelateProductDifferenceMethod(samplesVector, peakAmpl) {
    let validIValues = this._getValidIntervals(samplesVector);
    if (validIValues.length === 0)
      return 0;
    let bestSinglePeriodInterval = this._findPeriodViaProductSums(samplesVector, validIValues);
    let bestMultiPeriodInterval = this._findAveragePeriodViaAverageDifferenceSums(
      samplesVector,
      bestSinglePeriodInterval
    );
    this._correlationScore = this._getCorrelationScore(
      samplesVector,
      Math.round(bestMultiPeriodInterval),
      peakAmpl
    );
    return this._micSampleRate / this._resampleDivisor / bestMultiPeriodInterval;
  }
  _getValidIntervals(samplesVector) {
    let length = samplesVector.length;
    let validIValues = [];
    let firstPeakIndex = -1;
    let readyForPeak = false;
    let lastValue = samplesVector[0];
    for (let i = 0; i < length; i++) {
      if (samplesVector[i] <= lastValue && readyForPeak) {
        if (firstPeakIndex !== -1) {
          let distance = i - firstPeakIndex;
          let frequencyToCheck = 44100 / distance;
          if (frequencyToCheck >= this._minFreq && frequencyToCheck <= this._maxFreq) {
            validIValues.push(i - firstPeakIndex);
          } else if (frequencyToCheck < this._minFreq) {
            break;
          }
        } else {
          firstPeakIndex = i;
        }
        readyForPeak = false;
      } else if (samplesVector[i] > lastValue) {
        readyForPeak = true;
      }
      lastValue = samplesVector[i];
    }
    return validIValues;
  }
  _findPeriodViaProductSums(samplesVector, validIValues) {
    let length = samplesVector.length;
    let sum;
    let greatestSum = -10;
    let greatestSumsInterval = -1;
    let quality = this._quality;
    for (let interval of validIValues) {
      sum = 0;
      for (let j = 0; j < length - interval; j += quality) {
        sum += samplesVector[j] * samplesVector[j + interval];
      }
      if (sum >= greatestSum) {
        greatestSum = sum;
        greatestSumsInterval = interval;
      }
    }
    return greatestSumsInterval;
  }
  _findAveragePeriodViaAverageDifferenceSums(samplesVector, bestSinglePeriodInterval) {
    let length = samplesVector.length;
    let minBufferSamples = 10;
    let totalPeriods = ~~(length / bestSinglePeriodInterval);
    totalPeriods = length % bestSinglePeriodInterval < minBufferSamples && totalPeriods > 1 ? totalPeriods - 1 : totalPeriods;
    let startingPoint = totalPeriods * bestSinglePeriodInterval;
    let bestAverage = -1;
    let bestIntervalIndex = startingPoint;
    let improvedCorrelation = false;
    let sum;
    let minIValueToCheck = startingPoint - minBufferSamples >= 0 ? startingPoint - minBufferSamples : 0;
    let currentAverage;
    for (let i = startingPoint; i > minIValueToCheck; i--) {
      sum = 0;
      for (let j = 0; j < length - i; j += 1) {
        sum += Math.abs(samplesVector[j] - samplesVector[j + i]);
      }
      currentAverage = sum / (length - i);
      if (currentAverage < bestAverage || i === startingPoint) {
        bestAverage = currentAverage;
        bestIntervalIndex = i;
        improvedCorrelation = i !== startingPoint ? true : false;
      } else {
        break;
      }
    }
    if (improvedCorrelation === false) {
      let maxIValue = startingPoint + minBufferSamples <= length ? startingPoint + minBufferSamples : length;
      for (let i = startingPoint; i < maxIValue; i++) {
        sum = 0;
        for (let j = 0; j < length - i; j += 1) {
          sum += Math.abs(samplesVector[j] - samplesVector[j + i]);
        }
        currentAverage = sum / (length - i);
        if (currentAverage < bestAverage || i === startingPoint) {
          bestAverage = currentAverage;
          bestIntervalIndex = i;
        } else {
          break;
        }
      }
    }
    return bestIntervalIndex / totalPeriods;
  }
  _getCorrelationScore(samplesVector, interval, peakAmpl) {
    if (peakAmpl <= 0)
      return 0;
    let length = samplesVector.length;
    let p1;
    let p2;
    let sum = 0;
    for (let i = 0; i < length - interval; i++) {
      p1 = samplesVector[i];
      p2 = samplesVector[i + interval];
      if (p1 >= p2)
        sum += p1 - p2;
      else
        sum += p2 - p1;
    }
    sum *= 1 / peakAmpl;
    let average = sum / (length - interval);
    let score = 1 - average;
    return score;
  }
  _notifyOfPitch(frequency, time, rms, peakAmpl) {
    let ev = new PitchRecEvent();
    ev.frequency = frequency;
    let midiUnrounded = 69 + 17.3123404907 * Math.log(frequency / 440);
    let roundedCents = 100 * Math.round(midiUnrounded);
    ev.cents = roundedCents;
    ev.pitchName = PitchUtils.getCommonPitchNameFromCents(roundedCents);
    ev.time = time;
    let tuningDelta = Math.round(midiUnrounded * 100) % 100;
    if (tuningDelta >= 50) {
      tuningDelta -= 100;
    }
    ev.tuning = tuningDelta;
    ev.correlationScore = this._correlationScore;
    ev.rms = rms;
    ev.peakAmpl = peakAmpl;
    this._prEvents.push(ev);
    this._eventEmitter.emit(ev);
  }
};
var PitchRecEvent = class {
  constructor() {
    this.pitchSplit = false;
    this.amplSplit = false;
  }
};
PitchRecEvent.totalEvents = 0;
var _PitchUtils = class _PitchUtils {
  static getCommonPitchNameFromCents(cents) {
    let letter = cents >= 0 ? _PitchUtils.centPitchNames[cents / 100 % 12 * 100] : _PitchUtils.centPitchNames[(cents / 100 % 12 + 12) * 100];
    letter += (~~(cents / 1200) - 1).toString();
    return letter;
  }
};
_PitchUtils.centPitchNames = {
  0: "C",
  100: "C#",
  200: "D",
  300: "Eb",
  400: "E",
  500: "F",
  600: "F#",
  700: "G",
  800: "Ab",
  900: "A",
  1e3: "Bb",
  1100: "B"
};
var PitchUtils = _PitchUtils;

// src/analysis/PitchRecognizer2.ts
import { createEmitter as createEmitter6 } from "ts_utils";

// src/analysis/YinDetector.ts
var YinDetector = class {
  constructor() {
    this.threshold = 0.1;
    this.sampleRate = 44100;
    this.probabilityThreshold = 0.1;
    this.quality = 1;
  }
  getFrequency(samples) {
    let minInterval = Math.ceil(this.sampleRate / this.maxFreq) - 3;
    let maxInterval = Math.floor(this.sampleRate / this.minFreq);
    let bufferSize = 2 * maxInterval;
    if (bufferSize > samples.length) {
      return null;
    }
    while (bufferSize + maxInterval < samples.length) {
      bufferSize += maxInterval;
    }
    let yinBufferLength = maxInterval - minInterval + 1;
    let yinBuffer = new Array(yinBufferLength).fill(0);
    let probability = 0;
    let tau;
    for (let t = minInterval; t <= maxInterval; t++) {
      for (let i = 0; i < bufferSize - maxInterval; i += this.quality) {
        let delta = samples[i] - samples[i + t];
        yinBuffer[t - minInterval] += delta * delta;
      }
    }
    yinBuffer[0] = 1;
    yinBuffer[1] = 1;
    let runningSum = 0;
    for (let t = 1; t < yinBufferLength; t++) {
      runningSum += yinBuffer[t];
      yinBuffer[t] *= t / runningSum;
    }
    for (tau = 2; tau < yinBufferLength; tau++) {
      if (yinBuffer[tau] < this.threshold) {
        while (tau + 1 < yinBufferLength && yinBuffer[tau + 1] < yinBuffer[tau]) {
          tau++;
        }
        probability = 1 - yinBuffer[tau];
        break;
      }
    }
    if (tau === yinBufferLength || yinBuffer[tau] >= this.threshold) {
      return null;
    }
    if (probability < this.probabilityThreshold) {
      return null;
    }
    if (tau <= 2) {
      return null;
    }
    let betterTau;
    let x0;
    let x2;
    if (tau < 1) {
      x0 = tau;
    } else {
      x0 = tau - 1;
    }
    if (tau + 1 < yinBufferLength) {
      x2 = tau + 1;
    } else {
      x2 = tau;
    }
    if (x0 === tau) {
      if (yinBuffer[tau] <= yinBuffer[x2]) {
        betterTau = tau;
      } else {
        betterTau = x2;
      }
    } else if (x2 === tau) {
      if (yinBuffer[tau] <= yinBuffer[x0]) {
        betterTau = tau;
      } else {
        betterTau = x0;
      }
    } else {
      let s0 = yinBuffer[x0];
      let s1 = yinBuffer[tau];
      let s2 = yinBuffer[x2];
      betterTau = tau + (s2 - s0) / (2 * (2 * s1 - s2 - s0));
    }
    let result = new YinResult();
    result.frequency = this.sampleRate / (minInterval + betterTau);
    result.probability = probability;
    return result;
  }
};
var YinResult = class {
};

// src/analysis/PitchRecognizer2.ts
var PitchRecognizer2 = class {
  constructor(micManager) {
    /** the number of ms between readings*/
    this._msReadingInterval = 250;
    /** the minimum time period, in ms, that a reading should extend over*/
    this._msAnalysisDuration = 10;
    this._isRunning = false;
    this._eventEmitter = createEmitter6();
    this._onMicData = (data) => {
      this._samples.push(...data);
      let time = this._micManager.audioContext.currentTime;
      let durOfData = data.length / this._micSampleRate;
      if (this._recordDelay == -1) {
        this._recordDelay = time - this._recordTimeStamp - durOfData;
      }
      this._processData(time - durOfData);
    };
    this._micManager = micManager;
    this._init();
  }
  /**[true] when pitch rec is running*/
  get isRunning() {
    return this._isRunning;
  }
  get pitchRecEvent() {
    return this._eventEmitter.event;
  }
  _init() {
    this._yin = new YinDetector();
    this._micSampleRate = ~~this._micManager.audioContext.sampleRate;
    this._yin.sampleRate = this._micSampleRate;
    this.setInstrument(AssessmentInstrumentUtils.getInstrumentByID(3));
  }
  /** start pitch rec. */
  startPRec(startMicCapture, msReadingInterval = 250, msAnalysisDuration = 10) {
    this._msReadingInterval = msReadingInterval;
    this._msAnalysisDuration = msAnalysisDuration;
    this._prEvents = [];
    this._samples = [];
    this._currentStartPos = 0;
    this._recordDelay = -1;
    this._recordTimeStamp = this._micManager.audioContext.currentTime;
    this._micManager.micData.on(this._onMicData);
    if (startMicCapture) {
      this._micManager.startCapture();
    }
    this._isRunning = true;
  }
  stopPRec(stopMicCapture) {
    this._micManager.micData.off(this._onMicData);
    if (stopMicCapture) {
      this._micManager.stopCapture();
    }
    this._isRunning = false;
  }
  setInstrument(instDO) {
    this._minFreq = instDO.minFreq;
    this._maxFreq = instDO.maxFreq;
    this._yin.minFreq = this._minFreq;
    this._yin.maxFreq = this._maxFreq;
    this._yin.quality = instDO.yinQuality;
  }
  _processData(timeStamp) {
    let cTime = timeStamp;
    let maxPeriodSampleLength = Math.ceil(this._micSampleRate / this._minFreq);
    let analysisSampleDuration = Math.ceil(this._msAnalysisDuration / 1e3 * this._micSampleRate);
    if (analysisSampleDuration <= maxPeriodSampleLength) {
      analysisSampleDuration = 2 * maxPeriodSampleLength;
    } else {
      analysisSampleDuration = Math.ceil(analysisSampleDuration / maxPeriodSampleLength) * maxPeriodSampleLength;
    }
    while (this._samples.length - this._currentStartPos > analysisSampleDuration) {
      let startIndex = this._currentStartPos;
      let endIndex = startIndex + analysisSampleDuration;
      this._stats = this._calculateStats(startIndex, endIndex);
      this._stats.startTime = cTime;
      let samples = this._samples.slice(startIndex, endIndex + 1);
      let result = this._yin.getFrequency(samples);
      this._stats.frequency = result?.frequency ?? 0;
      this._stats.correlationScore = result?.probability ?? 0;
      if (this._stats.frequency > 0) {
        this._notifyOfPitch(this._stats);
      }
      cTime += this._msReadingInterval / 1e3;
      this._currentStartPos += Math.floor(
        this._msReadingInterval / 1e3 * this._micSampleRate
      );
    }
    if (this._currentStartPos > 0) {
      let end = Math.min(
        this._currentStartPos - 1,
        this._samples.length - 1
      );
      this._samples.splice(0, end);
      this._currentStartPos = 0;
    }
  }
  _calculateStats(startIndex, endIndex) {
    let sum = 0;
    let value;
    let peakAmpl = 0;
    for (let i = startIndex; i <= endIndex; i++) {
      value = this._samples[i];
      sum += value * value;
      if (value > peakAmpl) {
        peakAmpl = value;
      }
    }
    let stats = new _AnalysisStats();
    stats.peakAmpl = peakAmpl;
    stats.rms = Math.sqrt(sum / (endIndex - startIndex + 1));
    return stats;
  }
  _notifyOfPitch(stats) {
    let ev = new PitchRecEvent();
    ev.frequency = stats.frequency;
    let midiUnrounded = 69 + 17.3123404907 * Math.log(stats.frequency / 440);
    let roundedCents = 100 * Math.round(midiUnrounded);
    ev.cents = roundedCents;
    ev.pitchName = PitchUtils.getCommonPitchNameFromCents(roundedCents);
    ev.time = stats.startTime;
    let tuningDelta = Math.round(midiUnrounded * 100) % 100;
    if (tuningDelta >= 50) {
      tuningDelta -= 100;
    }
    ev.tuning = tuningDelta;
    ev.correlationScore = this._stats.correlationScore;
    ev.rms = stats.rms;
    ev.peakAmpl = stats.peakAmpl;
    this._prEvents.push(ev);
    this._eventEmitter.emit(ev);
  }
  /**Gets the most recent peak amplitude level or 0 if there have been no
   * readings*/
  get peakAmplitude() {
    return this._stats?.peakAmpl ?? 0;
  }
};
var _AnalysisStats = class {
};

// src/analysis/TuningProvider.ts
var _TuningProvider = class _TuningProvider {
  constructor(micManager) {
    this._isActive = false;
    this._isSilent = true;
    this._minAmplitude = 0.05;
    this._onPitchRec = (e) => {
      this._history.push(e);
      if (this._history.length > _TuningProvider.maxHistoryLength) {
        this._history.splice(0, 1);
      }
      if (e.peakAmpl < this._minAmplitude) {
        this._isSilent = true;
        return;
      }
      let numMatches = 0;
      let tuningSum = 0;
      for (let pre of this._history) {
        if (pre.cents == e.cents) {
          numMatches++;
          tuningSum += pre.tuning;
        }
      }
      if (numMatches >= _TuningProvider.minHistoryMatches) {
        let avgTuning = tuningSum / numMatches;
        this._lastPitchName = e.pitchName;
        this._lastCents = e.cents;
        this._lastTuning = Math.round(avgTuning);
        this._lastPitchMsTime = Math.floor(performance.now());
      }
    };
    this._pitchRecognizer = new PitchRecognizer2(micManager);
    this.setInstrument(3);
  }
  /**true if the tuner is currently listening for pitch results*/
  get isActive() {
    return this._isActive;
  }
  /**gets the cents, rounded to the nearest 100, of the most recent solid
   * reading. Will be null if no readings have occurred.*/
  get lastCents() {
    return this._lastCents;
  }
  /**gets the offset in cents, -50 to 50, of the most recent solid reading.
   * Will be null if no readings have occurred.*/
  get lastTuning() {
    return this._lastTuning;
  }
  /**gets the pitch name, with no number, of the most recent solid reading.
   * Will be null if no readings have occurred.*/
  get lastPitchName() {
    return this._lastPitchName;
  }
  /**gets the time, in seconds, since the last reported pitch reading. Can
   * be used to determine when to stop displaying pitch.*/
  get timeSinceLastPitch() {
    return (window.performance.now() - this._lastPitchMsTime) / 1e3;
  }
  /**returns true if the most recent reading registered below the 
   * [minAmplutide] level*/
  get isSilent() {
    return this._isSilent;
  }
  /**a value from 0 to 1.0 that sets the minimum microphone level that must
   * be met for tuning readings to be reported.*/
  get minAmplitude() {
    return this._minAmplitude;
  }
  set minAmplitude(value) {
    this._minAmplitude = value;
  }
  /**Gets the most recent peak amplitude level or 0 if there have been no
   * readings*/
  get peakAmplitude() {
    return this._pitchRecognizer.peakAmplitude;
  }
  start() {
    this._history = [];
    this._lastPitchMsTime = 0;
    this._pitchRecognizer.pitchRecEvent.on(this._onPitchRec);
    if (!this._pitchRecognizer.isRunning) {
      this._pitchRecognizer.startPRec(false);
    }
    this._isActive = true;
  }
  stop() {
    this._pitchRecognizer.pitchRecEvent.off(this._onPitchRec);
    this._isActive = false;
  }
  setInstrument(instrumentId) {
    let inst = AssessmentInstrumentUtils.getInstrumentByID(instrumentId);
    if (inst == null) {
      throw "InstrumentDO.id doesn't match an assessment inst";
    }
    this._pitchRecognizer.setInstrument(inst);
  }
};
_TuningProvider.maxHistoryLength = 10;
_TuningProvider.minHistoryMatches = 5;
var TuningProvider = _TuningProvider;

// src/audio_worklets/PRec2Node.ts
import { createEmitter as createEmitter7 } from "ts_utils";
var _PRec2Node = class _PRec2Node extends AudioWorkletNode {
  constructor() {
    super(MicManager.get().audioContext, "prec2-worklet");
    this._pitchRecEmitter = createEmitter7();
    this._onProcessorMessage = (ev) => {
      this._pitchRecEmitter.emit(ev.data);
    };
    if (!_PRec2Node.workletRegistered) {
      throw "call registerWorklet() before instantiating";
    }
    this._init();
  }
  get instrument() {
    return this._instrument;
  }
  get pitchRec() {
    return this._pitchRecEmitter.event;
  }
  static async registerWorklet(context) {
    if (_PRec2Node.workletRegistered) {
      return true;
    }
    try {
      let blob = new Blob([pRec2Worklet], { type: "text/javascript" });
      let url = window.URL.createObjectURL(blob);
      await context.audioWorklet.addModule(url);
      _PRec2Node.workletRegistered = true;
      return true;
    } catch (err) {
      console.log(err);
      return false;
    }
  }
  resetPRec(msReadingInterval = 250, msAnalysisDuration = 10) {
    this.port.postMessage({
      type: "reset",
      msReadingInterval,
      msAnalysisDuration
    });
  }
  setInstrument(instDO) {
    this._instrument = instDO;
    this.port.postMessage({
      type: "setInstrument",
      minFreq: instDO.minFreq,
      maxFreq: instDO.maxFreq,
      yinQuality: instDO.yinQuality
    });
  }
  _init() {
    this.port.onmessage = this._onProcessorMessage;
  }
};
_PRec2Node.workletRegistered = false;
var PRec2Node = _PRec2Node;
var pRec2Worklet = `
class PRec2Processor extends AudioWorkletProcessor {
	_minFreq;
	_maxFreq;
	
	_msReadingInterval = 250;
	_msAnalysisDuration = 10;
	
	_samples = [];
	_currentStartPos = 0;
	
	_lastLowPeakTime = 0;
	_lastPeak = 0;
	
	_yin;
	
	_centPitchNames = { 0:'C', 100:'C#', 200:'D', 300:'Eb', 400:'E', 500:'F',
		600:'F#', 700:'G', 800:'Ab', 900:'A', 1000:'Bb', 1100:'B' };
	
	constructor(){
		super();
		this._yin = new YinDetector();
		this._yin.sampleRate = sampleRate;
		this.port.onmessage = this._handleMessage;
	}
	
	_handleMessage = (ev) => {
		switch(ev.data.type){
			case "reset": {
				this._msReadingInterval = ev.data.msReadingInterval;
				this._msAnalysisDuration = ev.data.msAnalysisDuration;
				this._samples = [];
				this._currentStartPos = 0;
				break;
			}
			
			case "setInstrument": {
				this._minFreq = ev.data.minFreq;
				this._maxFreq = ev.data.maxFreq;
				this._yin.minFreq = ev.data.minFreq;
				this._yin.maxFreq = ev.data.maxFreq;
				this._yin.quality = ev.data.yinQuality;
				break;
			}
			
			default: {
				throw 'unsupported message type';
			}
		}
	}
	
	process(inputs, outputs){
		let data = inputs[0][0];
		if (data == null){
			return true;
		}
		
		this._samples.push(...data);
		
		let time = currentTime;
		let durOfData = data.length / sampleRate;
		
		this._processData(time - durOfData);
		
		return true;
	}
	
	_processData(timeStamp) {
		let cTime = timeStamp;
		
		//the duration, samples, of the longest possible single period for this
		//instrument.
		let maxPeriodSampleLength = Math.ceil(sampleRate / this._minFreq);
		//the target duration, in samples, of each chunk of data we'd like to 
		//analyze.
		let analysisSampleDuration = Math.ceil(this._msAnalysisDuration / 1000 * 
			sampleRate);
		//We'll increase the duration so that it's evenly divisible by
		//our maxPeriodSampleLength and ensure that we have at least 2 periods
		//worth of data to analyze
		if (analysisSampleDuration <= maxPeriodSampleLength){
			analysisSampleDuration = 2 * maxPeriodSampleLength;
		}
		else {
			analysisSampleDuration = Math.ceil(analysisSampleDuration / 
				maxPeriodSampleLength) * maxPeriodSampleLength;
		}
		
		// console.log(this._samples.length, this._currentStartPos,
		// 	analysisSampleDuration);
		
		while ((this._samples.length - this._currentStartPos) > 
				analysisSampleDuration){
			// let startTime = html.window.performance.now();
			
			let startIndex = this._currentStartPos;
			let endIndex = startIndex + analysisSampleDuration;
			
			this._stats = this._calculateStats(startIndex, endIndex, cTime);
			this._stats.startTime = cTime;
			
			let samples = this._samples.slice(startIndex, endIndex + 1);
			let result = this._yin.getFrequency(samples);
			if (result != null){
				this._stats.frequency = result.frequency;
				this._stats.correlationScore = result.probability;
				this._stats.hasPitch = true;
			}
			else {
				this._stats.frequency = 0;
				this._stats.correlationScore = 0;
				this._stats.hasPitch = false;
			}
			
			this._notifyOfPitch(this._stats);
			
			
			cTime += this._msReadingInterval / 1000;
			this._currentStartPos += Math.floor(
				(this._msReadingInterval  / 1000) * sampleRate);
			
			// print(html.window.performance.now() - startTime);
		}
		
		if (this._currentStartPos > 0){
			let end = Math.min(this._currentStartPos - 1,
				this._samples.length - 1);
			this._samples.splice(0, end);
			// this._samples.removeRange(0, end); //dart version
			this._currentStartPos = 0;
		}
	}
	
	_calculateStats(startIndex, endIndex, cTime) {
		let sum = 0;
		let value;
		let peakAmpl = this._samples[startIndex];
		let lastValue = this._samples[startIndex];
		let peakIndex = startIndex;
		let numDescending = 0;
		for (let i = startIndex; i <= endIndex; i++) {
			value = this._samples[i];
			sum += value * value;
			if (value < lastValue){
				numDescending++;
				if (numDescending === 1 && value > 0){
					if (lastValue > peakAmpl){
						peakAmpl = lastValue;
						peakIndex = i - 1;
					}
					if (lastValue < this._lastPeak){
						this._lastLowPeakTime = cTime + ((i - 1) / sampleRate);
					}
					this._lastPeak = lastValue;
				}
			}
			else {
				numDescending = 0;
			}
			lastValue = value;
		}
		
		let stats = new _AnalysisStats();
		stats.peakAmpl = peakAmpl;
		stats.rms = Math.sqrt(sum / (endIndex - startIndex + 1));
		return stats;
	}
	
	_notifyOfPitch(stats){
		let ev = {};
		ev.frequency = stats.frequency;
		
		let midiUnrounded = 69 + 17.3123404907 * 
			Math.log(stats.frequency / 440);
		let roundedCents = 100 * Math.round(midiUnrounded);
		ev.cents = roundedCents;
		ev.pitchName = this._getCommonPitchNameFromCents(roundedCents);
		ev.time = stats.startTime;
		//compute the tuning (distance from 100 cent multiple - ex. 23, -44,
		//etc.
		let tuningDelta = Math.round(midiUnrounded * 100) % 100;
		if (tuningDelta >= 50) {
			tuningDelta -= 100;
		}
		ev.tuning = tuningDelta;
		ev.correlationScore = this._stats.correlationScore;
		ev.hasPitch = this._stats.hasPitch;
		ev.rms = stats.rms;
		ev.peakAmpl = stats.peakAmpl;
		ev.lastLowPeakTime = this._lastLowPeakTime;
		
		this.port.postMessage(ev);
	}
	
	_getCommonPitchNameFromCents(cents) {
		//we really mean Dart's %12... -100 is a B, so -1%12 == 11
		let letter = (cents >= 0)
			? this._centPitchNames[(cents / 100) % 12 * 100]
			: this._centPitchNames[((cents / 100) % 12 + 12) * 100]
		letter += (~~(cents / 1200) - 1).toString();
		return letter;
	}
}

class _AnalysisStats {
	rms;
	peakAmpl;
	startTime;
	frequency;
	correlationScore;
	hasPitch;
}


class YinDetector {
	threshold = 0.1;
	sampleRate = 44100;
	probabilityThreshold = 0.1;
  
	minFreq;
	maxFreq;
	quality = 1;

	constructor() {}
	
	getFrequency(samples) {
		//start with the shortest possible period (the highest frequency)
		let minInterval = Math.ceil(this.sampleRate / this.maxFreq) - 3;
		let maxInterval = Math.floor(this.sampleRate / this.minFreq);
	
		// Set buffer size to the highest multiple of maxInterval below samples
		// length
		let bufferSize = 2 * maxInterval;
		if (bufferSize > samples.length){
			//not enough samples to analyze
			return null;
		}
		while (bufferSize + maxInterval < samples.length){
			bufferSize += maxInterval;
		}

		// Set up the yinBuffer as described in step one of the YIN paper.
		let yinBufferLength = maxInterval - minInterval + 1;
		let yinBuffer = new Array(yinBufferLength).fill(0.0);

		let probability = 0;
		let tau;

		// Compute the difference function as described in step 2 of the YIN
		//paper.
		for (let t = minInterval; t <= maxInterval; t++) {
			for (let i = 0; i < bufferSize - maxInterval; i += this.quality) {
				let delta = samples[i] - samples[i + t];
				yinBuffer[t - minInterval] += delta * delta;
			}
		}

		// Compute the cumulative mean normalized difference as described in
		//step 3 of the paper.
		yinBuffer[0] = 1;
		yinBuffer[1] = 1;
		let runningSum = 0;
		for (let t = 1; t < yinBufferLength; t++) {
			runningSum += yinBuffer[t];
			yinBuffer[t] *= t / runningSum;
		}

		// Compute the absolute threshold as described in step 4 of the paper.
		// Since the first two positions in the array are 1,
		// we can start at the third position.
		for (tau = 2; tau < yinBufferLength; tau++) {
			if (yinBuffer[tau] < this.threshold) {
				while (tau + 1 < yinBufferLength && 
						yinBuffer[tau + 1] < yinBuffer[tau]) {
					tau++;
				}
				// found tau, exit loop and return
				// store the probability
				// From the YIN paper: The threshold determines the list of
				// candidates admitted to the set, and can be interpreted as the
				// proportion of aperiodic power tolerated
				// within a periodic signal.
				//
				// Since we want the periodicity and and not aperiodicity:
				// periodicity = 1 - aperiodicity
				probability = 1 - yinBuffer[tau];
				break;
			}
		}

		// if no pitch found, return null.
		if (tau === yinBufferLength || yinBuffer[tau] >= this.threshold) {
			return null;
		}

		// If probability too low, return -1.
		if (probability < this.probabilityThreshold) {
			return null;
		}
		
		if (tau <= 2){
			// 2 seems to be the result we get when the mic is silent and
			// we just have room noise. It's better to lose a little more of
			// our maxFreq range and discard this result.
			return null;
		}

		/**
		 * Implements step 5 of the AUBIO_YIN paper. It refines the estimated
		 * tau value using parabolic interpolation. This is needed to detect
		 * higher frequencies more precisely. See
		 * http://fizyka.umk.pl/nrbook/c10-2.pdf and for more background
		 * http://fedc.wiwi.hu-berlin.de/xplore/tutorials/xegbohtmlnode62.html
		 */
		let betterTau;
		let x0;
		let x2;
		if (tau < 1) {
			x0 = tau;
		} 
		else {
			x0 = tau - 1;
		}
		if (tau + 1 < yinBufferLength) {
			x2 = tau + 1;
		} 
		else {
			x2 = tau;
		}
		if (x0 === tau) {
			if (yinBuffer[tau] <= yinBuffer[x2]) {
				betterTau = tau;
			} 
			else {
				betterTau = x2;
			}
		} 
		else if (x2 === tau) {
			if (yinBuffer[tau] <= yinBuffer[x0]) {
				betterTau = tau;
			} 
			else {
				betterTau = x0;
			}
		} 
		else {
			let s0 = yinBuffer[x0];
			let s1 = yinBuffer[tau];
			let s2 = yinBuffer[x2];
			// fixed AUBIO implementation, thanks to Karl Helgason:
			// (2.0f * s1 - s2 - s0) was incorrectly multiplied with -1
			betterTau = tau + (s2 - s0) / (2 * (2 * s1 - s2 - s0));
		}
		
		let result = new YinResult();
		result.frequency = this.sampleRate / (minInterval + betterTau);
		result.probability = probability;

		return result;
	}
}

class YinResult {
	frequency;
	probability;
}

registerProcessor('prec2-worklet', PRec2Processor);
`;

// src/analysis/TuningProvider2.ts
import { createEmitter as createEmitter8 } from "ts_utils";
var _TuningProvider2 = class _TuningProvider2 {
  constructor() {
    this._initialized = false;
    this._isActive = false;
    this._readingsActive = false;
    this._isSilent = true;
    this._minAmplitude = 0.05;
    this._sendPitchNoteEvents = false;
    this._emitter = createEmitter8();
    this._onPitchRec = (e) => {
      this._history.push(e);
      if (this._history.length > _TuningProvider2.maxHistoryLength) {
        this._history.splice(0, 1);
      }
      this._averageAmpl = (this._averageAmpl * this._numAmplReadings + e.peakAmpl) / (this._numAmplReadings + 1);
      this._numAmplReadings++;
      if (this._numAmplReadings > 12e4) {
        this._numAmplReadings = 12e4;
      }
      if (e.peakAmpl < this._minAmplitude) {
        this._isSilent = true;
        return;
      }
      if (!e.hasPitch) {
        return;
      }
      let numMatches = 0;
      let tuningSum = 0;
      for (let pre of this._history) {
        if (pre.cents === e.cents) {
          numMatches++;
          tuningSum += pre.tuning;
        }
      }
      if (numMatches >= _TuningProvider2.minHistoryMatches) {
        if (e.cents !== this._lastCents) {
          this._processPitchNote(e.cents);
        }
        let avgTuning = tuningSum / numMatches;
        this._lastPitchName = e.pitchName;
        this._lastCents = e.cents;
        this._lastTuning = Math.round(avgTuning);
        this._lastPitchMsTime = Math.floor(performance.now());
      }
    };
    this._onMicManagerEvent = (e) => {
      switch (e.type) {
        case 0 /* streamCreated */: {
          this.stop();
          this.start();
          break;
        }
        case 1 /* streamClosed */: {
          this._setReadingsStopped();
          break;
        }
      }
    };
  }
  /**true if the tuner is currently listening for pitch results*/
  get isActive() {
    return this._isActive;
  }
  get readingsActive() {
    return this._readingsActive;
  }
  get instrument() {
    return this._prec2Node.instrument;
  }
  /**gets the cents, rounded to the nearest 100, of the most recent solid
   * reading. Will be null if no readings have occurred.*/
  get lastCents() {
    return this._lastCents;
  }
  /**gets the offset in cents, -50 to 50, of the most recent solid reading.
   * Will be null if no readings have occurred.*/
  get lastTuning() {
    return this._lastTuning;
  }
  /**gets the pitch name, with no number, of the most recent solid reading.
   * Will be null if no readings have occurred.*/
  get lastPitchName() {
    return this._lastPitchName;
  }
  /**gets the time, in seconds, since the last reported pitch reading. Can
   * be used to determine when to stop displaying pitch.*/
  get timeSinceLastPitch() {
    return (window.performance.now() - this._lastPitchMsTime) / 1e3;
  }
  /**returns true if the most recent reading registered below the 
   * [minAmplutide] level*/
  get isSilent() {
    return this._isSilent;
  }
  /**a value from 0 to 1.0 that sets the minimum microphone level that must
   * be met for tuning readings to be reported.*/
  get minAmplitude() {
    return this._minAmplitude;
  }
  set minAmplitude(value) {
    this._minAmplitude = value;
  }
  /**Gets the most recent peak amplitude level or 0 if there have been no
   * readings*/
  get peakAmplitude() {
    return this._history != null && this._history.length > 0 ? this._history[this._history.length - 1].peakAmpl : 0;
  }
  get sendPitchNoteEvents() {
    return this._sendPitchNoteEvents;
  }
  set sendPitchNoteEvents(value) {
    this._sendPitchNoteEvents = value;
  }
  get averageAmpl() {
    return this._averageAmpl;
  }
  get event() {
    return this._emitter.event;
  }
  async init(context) {
    await PRec2Node.registerWorklet(context);
    this._prec2Node = new PRec2Node();
    this.setInstrument(3);
    this._initialized = true;
  }
  /**calling start() does not guarantee tuning events will immediately begin.
   * Listen for TuningProvider2EventType.readingsStarted/readingsStopped */
  start() {
    if (!this._initialized) {
      throw "you must call init() before using TuningProvider2 instance";
    }
    if (!this._isActive) {
      let micManager = MicManager.get();
      micManager.event.on(this._onMicManagerEvent);
      this._history = [];
      this._lastPitchMsTime = 0;
      this._prec2Node.pitchRec.on(this._onPitchRec);
      this._averageAmpl = 0;
      this._numAmplReadings = 0;
      if (micManager.isStreamActive) {
        let context = micManager.audioContext;
        this._sourceNode = context.createMediaStreamSource(
          micManager.stream
        );
        this._prec2Node.resetPRec(250, 10);
        this._sourceNode.connect(this._prec2Node);
        this._prec2Node.connect(context.destination);
        this._setReadingsStarted();
      }
      this._isActive = true;
    }
  }
  stop() {
    if (this._isActive) {
      this._prec2Node.pitchRec.off(this._onPitchRec);
      this._prec2Node.disconnect();
      if (this._sourceNode != null) {
        this._sourceNode.disconnect();
        this._sourceNode = null;
      }
      MicManager.get().event.off(this._onMicManagerEvent);
      this._setReadingsStopped();
      this._isActive = false;
    }
  }
  setInstrument(instrumentId) {
    let inst = AssessmentInstrumentUtils.getInstrumentByID(instrumentId);
    if (inst == null) {
      throw "InstrumentDO.id doesn't match an assessment inst";
    }
    this._prec2Node.setInstrument(inst);
  }
  _processPitchNote(cents) {
    let firstEv;
    let peakAmpl = 0;
    for (let i = 0; i < this._history.length; i++) {
      let ev2 = this._history[i];
      if (ev2.cents === cents) {
        if (firstEv == null) {
          firstEv = ev2;
        }
        if (ev2.peakAmpl > peakAmpl) {
          peakAmpl = ev2.peakAmpl;
        }
      }
    }
    let ev = new TuningProvider2Event();
    ev.type = 2 /* newPitchNote */;
    ev.noteStartTime = firstEv.lastLowPeakTime;
    ev.noteCents = cents;
    ev.notePitchName = firstEv.pitchName;
    ev.notePeakAmpl = peakAmpl;
    this._emitter.emit(ev);
  }
  _setReadingsStarted() {
    this._readingsActive = true;
    let ev = new TuningProvider2Event();
    ev.type = 0 /* readingsStarted */;
    this._emitter.emit(ev);
  }
  _setReadingsStopped() {
    this._readingsActive = false;
    let ev = new TuningProvider2Event();
    ev.type = 1 /* readingsStopped */;
    this._emitter.emit(ev);
  }
};
_TuningProvider2.maxHistoryLength = 10;
_TuningProvider2.minHistoryMatches = 5;
var TuningProvider2 = _TuningProvider2;
var TuningProvider2Event = class {
};
var TuningProvider2EventType = /* @__PURE__ */ ((TuningProvider2EventType2) => {
  TuningProvider2EventType2[TuningProvider2EventType2["readingsStarted"] = 0] = "readingsStarted";
  TuningProvider2EventType2[TuningProvider2EventType2["readingsStopped"] = 1] = "readingsStopped";
  TuningProvider2EventType2[TuningProvider2EventType2["newPitchNote"] = 2] = "newPitchNote";
  return TuningProvider2EventType2;
})(TuningProvider2EventType || {});

// src/mic/AudioRecorder.ts
var AudioRecorder = class {
  constructor(micManager) {
    this._encodeLive = false;
    this._isRecording = false;
    this._onMicData = (data) => {
      if (this._encodeLive)
        this._encoder.encode([data]);
      else {
        this._audioChunks.push(Float32Array.from(data));
      }
    };
    this._micManager = micManager;
  }
  /**
   * start recording.
   * set startMicCapture to true if you aren't initializing it elsewhere
   * (for pitch rec, etc.).
   */
  record(startMicCapture) {
    if (this._encoder != null) {
      this._encoder.cancel();
    }
    if (this._encodeLive) {
      this._initOggEncoder();
    } else
      this._audioChunks = [];
    this._micManager.micData.on(this._onMicData);
    if (startMicCapture) {
      this._micManager.startCapture();
    }
    this._recordStartTime = this._micManager.audioContext.currentTime;
    this._isRecording = true;
  }
  /**stops recording. If stopMicCapture is true, the microphone capture is
   * also stopped in the MicManager.*/
  stop(stopMicCapture) {
    if (this._isRecording) {
      this._micManager.micData.off(this._onMicData);
      if (stopMicCapture) {
        this._micManager.stopCapture();
      }
      this._recordStopTime = this._micManager.audioContext.currentTime;
      this._isRecording = false;
    }
  }
  /**Gets the recorded audio as an AudioBuffer.
   * @stereo - if true, mono recording is copied to both channels
   * @resampleRate - default null means no resampling. If specified, must
   * be a value lower than AudioContext's sample rate.
   * @deleteRecordedAudio - clears audio data from this class so it can be
   * garbage collected.*/
  async getAudioBuffer(stereo, resampleRate = null, deleteRecordedAudio = true) {
    if (this._audioChunks == null || this.encodeLive) {
      return null;
    }
    let length = 0;
    for (let chunk of this._audioChunks) {
      length += chunk.length;
    }
    let context = this._micManager.audioContext;
    let numChannels = stereo ? 2 : 1;
    let buffer = context.createBuffer(
      numChannels,
      length,
      context.sampleRate
    );
    let position = 0;
    for (let chunk of this._audioChunks) {
      for (let i = 0; i < numChannels; i++) {
        buffer.copyToChannel(chunk, i, position);
      }
      position += chunk.length;
    }
    if (deleteRecordedAudio) {
      this._audioChunks = null;
    }
    if (resampleRate == null || resampleRate >= context.sampleRate) {
      return buffer;
    } else {
      let resampleLength = Math.ceil(resampleRate / context.sampleRate * length);
      let oac = new OfflineAudioContext(
        numChannels,
        resampleLength,
        resampleRate
      );
      let bsn = oac.createBufferSource();
      bsn.buffer = buffer;
      bsn.connect(oac.destination);
      bsn.start(0);
      let renderedBuffer = await oac.startRendering();
      bsn.disconnect();
      bsn = null;
      buffer = null;
      oac = null;
      return renderedBuffer;
    }
  }
  /**gets recording as an html.Blob object that can be saved to a file*/
  getOggAudioBlob() {
    let recording;
    if (this._encoder == null) {
      this._initOggEncoder();
    }
    if (this._encoder != null) {
      if (!this._encodeLive && this._audioChunks != null) {
        while (this._audioChunks.length > 0) {
          this._encoder.encode([this._audioChunks.splice(0, 1)[0]]);
        }
      }
      recording = this._encoder.finish("audio/ogg");
      this._encoder = null;
      this._audioChunks = null;
    }
    return recording;
  }
  /**converts an audioBlob (typically from getOggAudioBlob()) into an
   * AudioBuffer object that can be used with an AudioBufferSourceNode.
   * After making a recording (or reloading one from a server), use
   * getOggAudioBlob() to get the recording as an html.Blob object. Then
   * pass that to this getAudioBuffer() method and wait for the result
   * of the future, which will be the AudioBuffer object. To play it, use
   * something like:
   * let playbackNode = context.createBufferSource();
   * _playbackNode.buffer = audioBuffer;
   * _playbackNode.connectNode(context.destination);
   * _playbackNode.start(0);*/
  getAudioBufferFromBlob(audioBlob) {
    return new Promise((resolve, reject) => {
      let reader = new FileReader();
      reader.onloadend = async (e) => {
        reader.onloadend = null;
        reader.onerror = null;
        let context = this._micManager.audioContext;
        let ab = await context.decodeAudioData(
          reader.result
        );
        resolve(ab);
      };
      reader.onerror = (e) => {
        reader.onloadend = null;
        reader.onerror = null;
        reject();
      };
      reader.readAsArrayBuffer(audioBlob);
    });
  }
  _initOggEncoder() {
    this._encoder = new window.OggVorbisEncoder(
      Math.floor(this._micManager.audioContext.sampleRate),
      1,
      0.5
    );
  }
  /**default is false. If true, ogg encoding happens in real time as date is
   * received. Could create performance issues (but seems pretty fast)*/
  get encodeLive() {
    return this._encodeLive;
  }
  set encodeLive(value) {
    this._encodeLive = value;
  }
  /**true when recording is active*/
  get isRecording() {
    return this._isRecording;
  }
  /**returns the AudioContext time, in seconds, when recording starts.*/
  get recordStartTime() {
    return this._recordStartTime;
  }
  /**returns the AudioContext time, in seconds, when recording stops.*/
  get recordStopTime() {
    return this._recordStopTime;
  }
};

// src/mic/AudioRecordJob.ts
import ysFixWebmDuration2 from "fix-webm-duration";
var AudioRecordJob = class _AudioRecordJob {
  constructor(micManager) {
    this._isRecording = false;
    this._fixWebmDuration = false;
    this._onDataAvailable = (e) => {
      this._recordingBlobs.push(e.data);
      if (!this._isRecording) {
        this._mediaRecorder.removeEventListener(
          "dataavailable",
          this._onDataAvailable
        );
        this._recordingComplete = true;
        this._completeBlobReturn();
      }
    };
    this._onMicManagerEvent = (e) => {
      switch (e.type) {
        case 1 /* streamClosed */:
          if (this._isRecording) {
            this.stop();
            this._recordingBlobs = null;
          }
          this._killMediaRecorder();
          break;
        case 0 /* streamCreated */:
          if (this._isRecording) {
            this.stop();
            this._recordingBlobs = null;
          }
          this._createMediaRecorder();
          break;
      }
    };
    this._micManager = micManager;
    this._init();
  }
  /**
   * start recording.
   * set startMicCapture to true if you aren't initializing it elsewhere
   * (for pitch rec, etc.).
   */
  record() {
    if (!_AudioRecordJob.isSupported) {
      return false;
    }
    if (this._mediaRecorder == null) {
      if (!this._createMediaRecorder()) {
        throw "MediaRecorder could not be created. Make sure to call MicManager.initMicMediaStream before using.";
      }
    }
    this._recordingBlobs = [];
    this._mediaRecorder.addEventListener(
      "dataavailable",
      this._onDataAvailable
    );
    this._mediaRecorder.start();
    this._recordStartTime = this._micManager.audioContext.currentTime;
    this._isRecording = true;
    this._recordingComplete = false;
    return true;
  }
  /**stops recording.*/
  stop() {
    if (!_AudioRecordJob.isSupported) {
      return;
    }
    if (this._isRecording) {
      this._mediaRecorder.stop();
      this._recordStopTime = this._micManager.audioContext.currentTime;
      this._isRecording = false;
    }
  }
  /**gets recording as an html.Blob object that can be saved to a file*/
  getAudioBlob() {
    return new Promise((resolve, reject) => {
      this._returnBlobCompleter = resolve;
      if (this._recordingComplete) {
        this._completeBlobReturn();
      }
    });
  }
  /**Gets an AudioElement with the recorded audio*/
  async getAudioElement() {
    let blob = await this.getAudioBlob();
    if (blob != null) {
      let audioEl = document.createElement("audio");
      audioEl.src = URL.createObjectURL(blob);
      return audioEl;
    }
    return null;
  }
  dispose() {
    this._micManager.event.off(this._onMicManagerEvent);
    this._mediaRecorder.removeEventListener(
      "dataavailable",
      this._onDataAvailable
    );
    this.stop();
    this._mediaRecorder = null;
    this._recordingBlobs = null;
    this._returnBlobCompleter = null;
  }
  _init() {
    this._micManager.event.on(this._onMicManagerEvent);
    this._createMediaRecorder();
  }
  _createMediaRecorder() {
    if (!this._audioStreamIsReady()) {
      return false;
    }
    try {
      let audioOptions = this._micManager.audioOptions;
      let options = {
        "mimeType": audioOptions.mimeCodecsString,
        "audioBitsPerSecond": audioOptions.bitRate
      };
      this._mediaRecorder = new MediaRecorder(
        this._micManager.stream,
        options
      );
      return true;
    } catch (err) {
      console.log(err.toString());
      return false;
    }
  }
  _audioStreamIsReady() {
    let audioStreams = this._micManager.stream?.getAudioTracks();
    if (audioStreams == null || audioStreams.length < 1 || audioStreams[0].readyState !== "live") {
      return false;
    }
    return true;
  }
  _completeBlobReturn() {
    if (this._returnBlobCompleter == null) {
      return;
    }
    if (this._recordingBlobs == null || this._recordingBlobs.length === 0) {
      this._recordingBlobs = null;
      this._returnBlobCompleter(null);
      this._returnBlobCompleter = null;
    } else {
      let mimeType = MediaFileUtils.getMimeType(
        this._micManager.audioOptions.mimeCodecsString
      );
      let blob = new Blob(this._recordingBlobs, { type: mimeType });
      this._recordingBlobs = null;
      if (!this._fixWebmDuration || !mimeType.includes("webm")) {
        this._returnBlobCompleter(blob);
        this._returnBlobCompleter = null;
      } else {
        let duration = Math.ceil((this._recordStopTime - this._recordStartTime) * 1e3);
        ysFixWebmDuration2(blob, duration, (fixedBlob) => {
          this._returnBlobCompleter(fixedBlob);
          this._returnBlobCompleter = null;
        }, { logger: false });
      }
    }
  }
  _killMediaRecorder() {
    if (this._mediaRecorder != null) {
      this._mediaRecorder.removeEventListener(
        "dataavailable",
        this._onDataAvailable
      );
      this._mediaRecorder = null;
    }
  }
  /**if true, recording is currently in progress.*/
  get isRecording() {
    return this._isRecording;
  }
  /**returns the AudioContext time, in seconds, when recording starts.*/
  get recordStartTime() {
    return this._recordStartTime;
  }
  /**returns the AudioContext time, in seconds, when recording stops.*/
  get recordStopTime() {
    return this._recordStopTime;
  }
  /**returns the duration of recording, in seconds (not rounded) */
  get recordDuration() {
    return this._recordStopTime - this.recordStartTime;
  }
  /**if true, webm recordings will be processed to add duration metadata */
  get fixWebmDuration() {
    return this._fixWebmDuration;
  }
  set fixWebmDuration(value) {
    this._fixWebmDuration = value;
  }
  /**returns true if the browser supports the MediaRecorder API*/
  static get isSupported() {
    if (_AudioRecordJob._isSupported == null) {
      _AudioRecordJob._isSupported = MediaRecorder != null;
    }
    return _AudioRecordJob._isSupported;
  }
};

// src/video/VideoCodecConverter.ts
import { convertMedia } from "@remotion/webcodecs";
var VideoCodecConverter = class {
  convert(blob, params) {
    return new Promise((resolve, reject) => {
      convertMedia({
        src: blob,
        container: "mp4",
        videoCodec: "h264",
        expectedDurationInSeconds: Math.ceil(params.duration),
        expectedFrameRate: params.fps
      }).then(async (result) => {
        try {
          let converted = await result.save();
          resolve(converted);
        } catch (err2) {
          console.log(err2);
          resolve(null);
        }
      }).catch((err) => {
        console.log(err);
        resolve(null);
      });
    });
  }
};

// src/video/VideoManager.ts
import { createEmitter as createEmitter9 } from "ts_utils";
var VideoManager = class _VideoManager {
  /**Creates/gets a [VideoManager] singleton. [context] and [VideoOptions] are
   * only necessary the first time the constructor is called and will be 
   * ignored on future calls.*/
  constructor(context, options) {
    this._use720PForCanvasStream = true;
    this._createCanvasSnapshots = false;
    this._eventEmitter = createEmitter9();
    this._onMediaDeviceManagerEvent = (e) => {
      if (e.cameraChanged) {
        this.killStream();
      }
    };
    this._onCanvasTimer = () => {
      let origWidth = this._canvasVideoEl.videoWidth;
      let origHeight = this._canvasVideoEl.videoHeight;
      let targetWidth = this._options.width;
      let targetHeight = this._options.height;
      if (origWidth === 0 || origHeight === 0) {
        this._ctx2d.fillStyle = "rgba(0,0,0,0)";
        this._ctx2d.fillRect(0, 0, 1, 1);
      } else {
        if (this._canvasVideoEl.height !== origHeight) {
          this._canvasVideoEl.height = origHeight;
          this._canvasVideoEl.width = origWidth;
        }
        let scale = origHeight / targetHeight;
        let sWidth = targetWidth * scale;
        let sx = (origWidth - sWidth) / 2;
        this._ctx2d.drawImage(
          this._canvasVideoEl,
          sx,
          0,
          sWidth,
          origHeight,
          0,
          0,
          targetWidth,
          targetHeight
        );
      }
      if (this._createCanvasSnapshots) {
        createImageBitmap(this._canvas).then((img) => {
          let ev = new VideoManagerEvent(
            2 /* canvasSnapshot */
          );
          ev.canvasSnapshot = img;
          this._eventEmitter.emit(ev);
        });
      }
      this._canvasTimerId = window.setTimeout(
        this._onCanvasTimer,
        1e3 / this._options.idealFrameRate
      );
    };
    this._init(context, options);
  }
  get event() {
    return this._eventEmitter.event;
  }
  static get(context, options) {
    if (!_VideoManager._ref) {
      _VideoManager._ref = new _VideoManager(context, options);
    }
    return _VideoManager._ref;
  }
  _init(context, options) {
    if (context == null) {
      throw "AudioContext must be specified the first time you call the VideoManager constructor.";
    }
    if (options == null) {
      throw "VideoOptions must be specified the first time you call the VideoManager constructor";
    }
    if (!MediaDeviceManager.isInitialized) {
      throw "You must instantiate and initialize a MediaDeviceManager before creating the VideoManager";
    }
    this._context = context;
    this._options = options;
    _VideoManager._ref = this;
    MediaDeviceManager.get().event.on(this._onMediaDeviceManagerEvent);
  }
  /**kills any existing media stream and initializes a new one. If successful,
   * resolves true, otherwise false.*/
  async initVideoMediaStream(width, height) {
    let deviceManager = MediaDeviceManager.get();
    if (!deviceManager.isCameraReady) {
      throw "You must set a camera device in the MediaDeviceManager and get permission to use it before adding a video stream";
    }
    this.killStream();
    let options = this._options.toMap(deviceManager.currentCamera.id);
    if (width != null) {
      options["width"] = { "ideal": width };
    }
    if (height != null) {
      options["height"] = { "ideal": height };
    }
    try {
      this._stream = await navigator.mediaDevices.getUserMedia(
        { video: options }
      );
      if (this._useCanvasStream) {
        await this._startCanvasStream();
      }
      let ev = new VideoManagerEvent(0 /* streamCreated */);
      this._eventEmitter.emit(ev);
      return true;
    } catch (err) {
      console.log(err.toString() + " ...maybe make sure camera is enabled.");
      return false;
    }
  }
  killStream() {
    if (this._stream != null) {
      this._stopCanvasStream();
      let tracks = this._stream.getTracks();
      for (let i = tracks.length - 1; i >= 0; i--) {
        let track = tracks[i];
        track.stop();
        track.enabled = false;
        this._stream.removeTrack(track);
      }
      this._stream = null;
      let ev = new VideoManagerEvent(1 /* streamClosed */);
      this._eventEmitter.emit(ev);
    }
  }
  async _startCanvasStream() {
    this._canvas = document.createElement("canvas");
    this._canvas.width = this._options.width;
    this._canvas.height = this._options.height;
    this._ctx2d = this._canvas.getContext("2d");
    this._canvasStream = this._canvas.captureStream(
      this._options.idealFrameRate
    );
    this._canvasVideoEl = document.createElement("video");
    this._canvasVideoEl.srcObject = this._stream;
    await this._canvasVideoEl.play();
    this._onCanvasTimer();
  }
  _stopCanvasStream() {
    if (this._canvasTimerId == null) {
      return;
    }
    window.clearTimeout(this._canvasTimerId);
    this._canvasTimerId = null;
    if (this._canvasVideoEl != null) {
      this._canvasVideoEl.pause();
      this._canvasVideoEl = null;
    }
    this._ctx2d = null;
    this._canvas = null;
    this._canvasStream = null;
  }
  get audioContext() {
    return this._context;
  }
  set audioContext(value) {
    this._context = value;
  }
  get videoOptions() {
    return this._options;
  }
  get stream() {
    return this._stream;
  }
  /**returns the [MediaStreamTrack] for the camera video*/
  get cameraVideoTrack() {
    return this._stream?.getVideoTracks()[0];
  }
  /**if true, whenever a stream is initialized, a second stream will also be
   * generated and accessible via the canvasStream property. This can only
   * be set when no stream is active. Note that when using a canvas stream,
   * it may help to pass a common 16/9 resolution to initVideoMediaStream().
   * For example, 1280 X 720*/
  get useCanvasStream() {
    return this._useCanvasStream;
  }
  set useCanvasStream(value) {
    if (this._stream != null) {
      throw "can not set while a current video stream exists. Use killStream() first or call before first stream initialization";
    }
    this._useCanvasStream = value;
  }
  /**a generated stream meant to enforce the exact width, height and framerate
   * from the VideoOptions. */
  get canvasStream() {
    return this._canvasStream;
  }
  /**returns the [MediaStreamTrack] for the canvas video*/
  get canvasVideoTrack() {
    return this._canvasStream?.getVideoTracks()[0];
  }
  /**if true, when the canvas stream is enabled, snapshots will be taken of
   * each frame and dispatched via a VideoManagerEvent. */
  get createCanvasSnapshots() {
    return this._createCanvasSnapshots;
  }
  set createCanvasSnapshots(value) {
    this._createCanvasSnapshots = value;
  }
};
var VideoManagerEvent = class {
  constructor(type) {
    this.type = type;
  }
};
var VideoManagerEventType = /* @__PURE__ */ ((VideoManagerEventType2) => {
  VideoManagerEventType2[VideoManagerEventType2["streamCreated"] = 0] = "streamCreated";
  VideoManagerEventType2[VideoManagerEventType2["streamClosed"] = 1] = "streamClosed";
  VideoManagerEventType2[VideoManagerEventType2["canvasSnapshot"] = 2] = "canvasSnapshot";
  return VideoManagerEventType2;
})(VideoManagerEventType || {});

// src/video/VideoRecorder.ts
import ysFixWebmDuration3 from "fix-webm-duration";
var VideoRecorder = class _VideoRecorder {
  constructor(videoManager) {
    this._isRecording = false;
    this._fixWebmDuration = false;
    this._onDataAvailable = (e) => {
      this._recordingBlobs.push(e.data);
      if (!this._isRecording) {
        this._mediaRecorder.removeEventListener(
          "dataavailable",
          this._onDataAvailable
        );
        this._recordingComplete = true;
        this._completeBlobReturn();
      }
    };
    this._onVideoManagerEvent = (e) => {
      switch (e.type) {
        case 1 /* streamClosed */:
          if (this._isRecording) {
            this.stop();
            this._recordingBlobs = null;
          }
          this._killMediaRecorder();
          break;
        case 0 /* streamCreated */:
          if (this._isRecording) {
            this.stop();
            this._recordingBlobs = null;
          }
          this._createMediaRecorder();
          break;
      }
    };
    this._videoManager = videoManager;
    this._init();
  }
  /** start recording.*/
  record() {
    if (!_VideoRecorder.isSupported) {
      return false;
    }
    if (this._mediaRecorder == null) {
      if (!this._createMediaRecorder()) {
        throw "MediaRecorder could not be created. Make sure to call VideoManager.initVideoMediaStream before using the VideoRecorder";
      }
    }
    this._recordingBlobs = [];
    this._mediaRecorder.addEventListener(
      "dataavailable",
      this._onDataAvailable
    );
    this._clipEndTime = null;
    this._mediaRecorder.start(
      this._videoManager.videoOptions.recordingBlobSize
    );
    this._recordStartTime = this._videoManager.audioContext.currentTime;
    this._isRecording = true;
    this._recordingComplete = false;
    return true;
  }
  /**stops recording.*/
  stop() {
    if (!_VideoRecorder.isSupported) {
      return;
    }
    if (this._isRecording) {
      this._mediaRecorder.stop();
      this._recordStopTime = this._videoManager.audioContext.currentTime;
      this._isRecording = false;
    }
  }
  /**gets recording as an html.Blob object that can be saved to a file. 
   * Optionally set and [endTime] in seconds to clip the video before
   * returning the blob. Clipping resolution will be limited by the
   * [VideoOptions.recordingBlobSize]*/
  getVideoBlob(endTime) {
    return new Promise((resolve, reject) => {
      this._returnBlobCompleter = resolve;
      this._clipEndTime = endTime;
      if (this._recordingComplete) {
        this._completeBlobReturn();
      }
    });
  }
  /**Gets a VideoElement with the recorded video*/
  async getVideoElement() {
    let blob = await this.getVideoBlob();
    if (blob != null) {
      let videoEl = document.createElement("video");
      videoEl.src = URL.createObjectURL(blob);
      return videoEl;
    }
    return null;
  }
  _init() {
    this._videoManager.event.on(this._onVideoManagerEvent);
    this._createMediaRecorder();
  }
  _createMediaRecorder() {
    this._killMediaRecorder();
    if (!this._videoStreamIsReady()) {
      return false;
    }
    try {
      let stream = this._videoManager.useCanvasStream ? this._videoManager.canvasStream : this._videoManager.stream;
      let vidOptions = this._videoManager.videoOptions;
      this._mediaRecorder = new MediaRecorder(stream, {
        "mimeType": vidOptions.mimeCodecsString,
        "videoBitsPerSecond": vidOptions.bitRate
      });
      return true;
    } catch (err) {
      console.log(err.toString());
      return false;
    }
  }
  _videoStreamIsReady() {
    let stream = this._videoManager.useCanvasStream ? this._videoManager.canvasStream : this._videoManager.stream;
    let videoTracks = stream?.getVideoTracks();
    if (videoTracks == null || videoTracks.length < 1 || videoTracks[0].readyState !== "live") {
      return false;
    }
    return true;
  }
  _completeBlobReturn() {
    if (this._returnBlobCompleter == null) {
      return;
    }
    if (this._recordingBlobs == null || this._recordingBlobs.length == 0) {
      this._recordingBlobs = null;
      this._returnBlobCompleter(null);
      this._returnBlobCompleter = null;
    } else {
      let blobSize = this._videoManager.videoOptions.recordingBlobSize / 1e3;
      if (this._clipEndTime != null) {
        let endIndex = Math.ceil(this._clipEndTime / blobSize);
        if (endIndex < this._recordingBlobs.length) {
          this._recordingBlobs.splice(
            endIndex,
            this._recordingBlobs.length
          );
        }
      }
      let codecStr = this._videoManager.videoOptions.mimeCodecsString;
      let mimeType = MediaFileUtils.getMimeType(codecStr);
      let blob = new Blob(this._recordingBlobs, { type: mimeType });
      this._recordingBlobs = null;
      this._fixOutput(blob, mimeType).then((fixedBlob) => {
        this._returnBlobCompleter(fixedBlob);
        this._returnBlobCompleter = null;
      });
    }
  }
  async _fixOutput(blob, mimeType) {
    return new Promise((resolve, reject) => {
      if (this._fixWebmDuration && mimeType.includes("webm")) {
        let duration = Math.ceil((this._recordStopTime - this._recordStartTime) * 1e3);
        ysFixWebmDuration3(blob, duration, (fixedBlob) => {
          resolve(fixedBlob);
        }, { logger: false });
      } else {
        resolve(blob);
      }
    });
  }
  _killMediaRecorder() {
    if (this._mediaRecorder != null) {
      this._mediaRecorder.removeEventListener(
        "dataavailable",
        this._onDataAvailable
      );
      this._mediaRecorder = null;
    }
  }
  /**if true, recording is currently in progress.*/
  get isRecording() {
    return this._isRecording;
  }
  /**returns the AudioContext time, in seconds, when recording starts.*/
  get recordStartTime() {
    return this._recordStartTime;
  }
  /**returns the AudioContext time, in seconds, when recording stops.*/
  get recordStopTime() {
    return this._recordStopTime;
  }
  /**returns the duration of recording, in seconds (not rounded) */
  get recordDuration() {
    return this._recordStopTime - this.recordStartTime;
  }
  /**if true, webm recordings will be processed to add duration metadata */
  get fixWebmDuration() {
    return this._fixWebmDuration;
  }
  set fixWebmDuration(value) {
    this._fixWebmDuration = value;
  }
  /**returns true if the browser supports the MediaRecorder API*/
  static get isSupported() {
    if (_VideoRecorder._isSupported == null) {
      _VideoRecorder._isSupported = MediaRecorder != null;
    }
    return _VideoRecorder._isSupported;
  }
};

// src/video/VideoRecordJob.ts
import ysFixWebmDuration4 from "fix-webm-duration";
var VideoRecordJob = class _VideoRecordJob {
  constructor(videoManager) {
    this._isRecording = false;
    this._fixWebmDuration = false;
    this._onDataAvailable = (e) => {
      this._recordingBlobs.push(e.data);
      if (!this._isRecording) {
        this._mediaRecorder.removeEventListener(
          "dataavailable",
          this._onDataAvailable
        );
        this._recordingComplete = true;
        this._completeBlobReturn();
      }
    };
    this._onVideoManagerEvent = (e) => {
      switch (e.type) {
        case 1 /* streamClosed */:
          if (this._isRecording) {
            this.stop();
            this._recordingBlobs = null;
          }
          this._killMediaRecorder();
          break;
        case 0 /* streamCreated */:
          if (this._isRecording) {
            this.stop();
            this._recordingBlobs = null;
          }
          this._createMediaRecorder();
          break;
      }
    };
    this._videoManager = videoManager;
    this._init();
  }
  /** start recording.*/
  record() {
    if (!_VideoRecordJob.isSupported) {
      return false;
    }
    if (this._mediaRecorder == null) {
      if (!this._createMediaRecorder()) {
        throw "MediaRecorder could not be created. Make sure to call VideoManager.initVideoMediaStream before using";
      }
    }
    this._recordingBlobs = [];
    this._mediaRecorder.addEventListener(
      "dataavailable",
      this._onDataAvailable
    );
    this._clipEndTime = null;
    this._mediaRecorder.start(
      this._videoManager.videoOptions.recordingBlobSize
    );
    this._recordStartTime = this._videoManager.audioContext.currentTime;
    this._isRecording = true;
    this._recordingComplete = false;
    return true;
  }
  /**stops recording.*/
  stop() {
    if (!_VideoRecordJob.isSupported) {
      return;
    }
    if (this._isRecording) {
      this._mediaRecorder.stop();
      this._recordStopTime = this._videoManager.audioContext.currentTime;
      this._isRecording = false;
    }
  }
  /**gets recording as an html.Blob object that can be saved to a file. 
   * Optionally set and [endTime] in seconds to clip the video before
   * returning the blob. Clipping resolution will be limited by the
   * [VideoOptions.recordingBlobSize]*/
  getVideoBlob(endTime) {
    return new Promise((resolve, reject) => {
      this._returnBlobCompleter = resolve;
      this._clipEndTime = endTime;
      if (this._recordingComplete) {
        this._completeBlobReturn();
      }
    });
  }
  /**Gets a VideoElement with the recorded video*/
  async getVideoElement() {
    let blob = await this.getVideoBlob();
    if (blob != null) {
      let videoEl = document.createElement("video");
      videoEl.src = URL.createObjectURL(blob);
      return videoEl;
    }
    return null;
  }
  dispose() {
    this._videoManager.event.off(this._onVideoManagerEvent);
    this._mediaRecorder.removeEventListener(
      "dataavailable",
      this._onDataAvailable
    );
    this.stop();
    this._mediaRecorder = null;
    this._recordingBlobs = null;
    this._returnBlobCompleter = null;
  }
  _init() {
    this._videoManager.event.on(this._onVideoManagerEvent);
    this._createMediaRecorder();
  }
  _createMediaRecorder() {
    if (!this._videoStreamIsReady()) {
      return false;
    }
    try {
      let stream = this._videoManager.useCanvasStream ? this._videoManager.canvasStream : this._videoManager.stream;
      let vidOptions = this._videoManager.videoOptions;
      this._mediaRecorder = new MediaRecorder(stream, {
        "mimeType": vidOptions.mimeCodecsString,
        "videoBitsPerSecond": vidOptions.bitRate
      });
      return true;
    } catch (err) {
      console.log(err.toString());
      return false;
    }
  }
  _videoStreamIsReady() {
    let stream = this._videoManager.useCanvasStream ? this._videoManager.canvasStream : this._videoManager.stream;
    let videoTracks = stream?.getVideoTracks();
    if (videoTracks == null || videoTracks.length < 1 || videoTracks[0].readyState !== "live") {
      return false;
    }
    return true;
  }
  _completeBlobReturn() {
    if (this._returnBlobCompleter == null) {
      return;
    }
    if (this._recordingBlobs == null || this._recordingBlobs.length == 0) {
      this._recordingBlobs = null;
      this._returnBlobCompleter(null);
      this._returnBlobCompleter = null;
    } else {
      let blobSize = this._videoManager.videoOptions.recordingBlobSize / 1e3;
      if (this._clipEndTime != null) {
        let endIndex = Math.ceil(this._clipEndTime / blobSize);
        if (endIndex < this._recordingBlobs.length) {
          this._recordingBlobs.splice(
            endIndex,
            this._recordingBlobs.length
          );
        }
      }
      let codecStr = this._videoManager.videoOptions.mimeCodecsString;
      let mimeType = MediaFileUtils.getMimeType(codecStr);
      let blob = new Blob(this._recordingBlobs, { type: mimeType });
      this._recordingBlobs = null;
      this._fixOutput(blob, mimeType).then((fixedBlob) => {
        this._returnBlobCompleter(fixedBlob);
        this._returnBlobCompleter = null;
      });
    }
  }
  async _fixOutput(blob, mimeType) {
    return new Promise((resolve, reject) => {
      if (this._fixWebmDuration && mimeType.includes("webm")) {
        let duration = Math.ceil((this._recordStopTime - this._recordStartTime) * 1e3);
        ysFixWebmDuration4(blob, duration, (fixedBlob) => {
          resolve(fixedBlob);
        }, { logger: false });
      } else {
        resolve(blob);
      }
    });
  }
  _killMediaRecorder() {
    if (this._mediaRecorder != null) {
      this._mediaRecorder.removeEventListener(
        "dataavailable",
        this._onDataAvailable
      );
      this._mediaRecorder = null;
    }
  }
  /**if true, recording is currently in progress.*/
  get isRecording() {
    return this._isRecording;
  }
  /**returns the AudioContext time, in seconds, when recording starts.*/
  get recordStartTime() {
    return this._recordStartTime;
  }
  /**returns the AudioContext time, in seconds, when recording stops.*/
  get recordStopTime() {
    return this._recordStopTime;
  }
  /**returns the duration of recording, in seconds (not rounded) */
  get recordDuration() {
    return this._recordStopTime - this.recordStartTime;
  }
  /**if true, webm recordings will be processed to add duration metadata */
  get fixWebmDuration() {
    return this._fixWebmDuration;
  }
  set fixWebmDuration(value) {
    this._fixWebmDuration = value;
  }
  /**returns true if the browser supports the MediaRecorder API*/
  static get isSupported() {
    if (_VideoRecordJob._isSupported == null) {
      _VideoRecordJob._isSupported = MediaRecorder != null;
    }
    return _VideoRecordJob._isSupported;
  }
};
export {
  AssessmentInstrumentDO,
  AssessmentInstrumentUtils,
  AudioOptions,
  AudioRecordJob,
  AudioRecorder,
  AudioRecorder2,
  DelayInfo,
  DelayTester,
  DelayTester2,
  Device,
  DeviceType,
  HitEvent,
  HitRecognizer,
  HitType,
  KeyHitRecognizer,
  MediaDeviceManager,
  MediaDeviceManagerEvent,
  MediaDeviceManagerEventType,
  MediaFileUtils,
  MicHitRecognizer,
  MicManager,
  MicManagerEvent,
  MicManagerEventType,
  MicOptions,
  MimeCodecsString,
  PitchRecEvent,
  PitchRecognizer,
  PitchRecognizer2,
  PitchUtils,
  TuningProvider,
  TuningProvider2,
  TuningProvider2Event,
  TuningProvider2EventType,
  VideoCodecConverter,
  VideoManager,
  VideoManagerEvent,
  VideoManagerEventType,
  VideoOptions,
  VideoRecordJob,
  VideoRecorder,
  YinDetector
};
